import { AfterViewInit, ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { appService } from '../../../_services/app.service';
import { CommonService } from '../../../_services/common.service';
import { NavService } from '../../../_services/NavService.service';
import { UserService } from '../../../auth/_services';
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';
import { MobileDetectionService } from '../../services/mobile-detection.service';
import { NetworkService } from '../../services/network/network.service';
import { Helpers } from '../../../helpers';
import { OrdersService } from '../../services/orders/orders.service';
import { FtlCostSheetComponent } from '../../../shared/components/ftl-cost-sheet/ftl-cost-sheet.component';
import { TransporterVehicleDriverCardModalComponent } from '../transporter-vehicle-driver-card-modal/transporter-vehicle-driver-card-modal.component';
import { ITableModel } from '../table/model/tableModel';
import { Label } from '@amcharts/amcharts4/core';
import { ConfirmationPopupComponent } from '../confirmation-popup/confirmation-popup.component';
import { getDate } from 'ngx-bootstrap/chronos/utils/date-getters';
import { environment } from "../../../../environments/environment";
import { Observable } from 'rxjs';
import { ChangeTranporterDriverHistoryComponent } from '../change-tranporter-driver-history/change-tranporter-driver-history.component';
import { PrintFormatsComponent } from '../../../print-formats/print-formats.component';
import { PrintFormatsNewComponent } from '../../../print-formats-new/print-formats-new.component';
import { QuotationlogComponent } from '../quotationlog/quotationlog.component';
import { UlipService } from '../../services/Ulip/ulip.service';
import { EwayBillService } from '../../services/EwayBill/eway-bill.service';
declare var google: any;

@Component({
  selector: 'app-truck-load-view',
  templateUrl: './truck-load-view.component.html',
  styleUrls: ['./truck-load-view.component.scss']
})
export class TruckLoadViewComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

  @Input() ScreenName: any = '';
  @Input() SelectedId: any;
  @Input() SelectedTransportService: any;
  hostUrl: any = environment.apiUrl;//added by BURHAN - 22-April-2026
  static that: TruckLoadViewComponent;
  isAttachmentShow: boolean;
  isAttachmentShowForPOD: boolean = false;
  hasEditAccess: Boolean = true;
  data: any = { Order: {}, Products: [], VehicleList: [] };
  YardAddress: any = '';
  modalRef: NgbModalRef | null = null;
  modalRefForHistory: NgbModalRef | null = null;
  modalRef1: NgbModalRef | null = null;

  TodayDate: any;
  ConsignmentNo: any;
  ConsignmentDetailId: any;
  PODRecevied: boolean = false;
  dataY: any = {};
  TransportService: any;
  @Input() DynamicMode: any = '';
  @Input() DynamicServiceMode: any;
  activeIndex: number = 0;
  showTripPage: boolean = false;
  //added by BURHAN - 22-April-2026
  GenerateManualLRNoIndent: any = false;
  isAutoNumberingFlag: any = false;
  //added - 6-May-2026
  isAttachmentShowForTrips: boolean = false;
  SelectedTripId: any;
  TripsDocumentType: string = 'Full Truck Load';
  //added - 27-May-2026
  @ViewChild('updateTrackingModal') updateTrackingModal: TemplateRef<any>; // comment by burhan - 27-May-2026
  trackingLinkValue: string = '';
  currentTrackingData: any = null;
  isUpdateTrackingMode: boolean = false;
  IsCalculateTravelTimeByVehicleKm: boolean = false; // Added by priya - 23/06/2026 - cn(PRIYA-JUN26-007)
  //end by BURHAN
  orderDetails: any = {
    cardName: "ORDER",
    id: "OrderDetails",
    icon_mb: "../../../../../assets/settings/account_mb.svg",
    listOfRow: [
      [
        { label: "Customer", dataField: 'CustomerName', dataField1: 'CustomerAddress', dataField2: 'CustomerContactPerson', dataField3: 'CustomerPhone', dataField4: 'CustomerEmail', isBoldText: true, isContact: true, isColorContact: true, isOrderCustomer: true, CustomerId: 'CustomerId' },
        { label: "Account Manager", dataField2: 'Salesperson', isContact: true, isColorContact: true },
        // dataField4: 'SalesPersonContactEmail', dataField3: 'SalesPersonContactPhone',
        { label: "Reference Details", dataField: 'ReferenceNo', dataField1: 'ReferenceDate', dataField2: 'InvoiceNo', dataField3: 'TransportName', isBoldText: true }
      ],
      [
        { isAccordion: true, dataFieldA: 'InvoiceDue', dataFieldA1: 'PaymentResponsibility', dataFieldA2: 'CreditLimit' }
      ]
    ]
  }
  
  shipmentOrderDetails: any = {
    cardName: "Order",
    id: "OrderDetails",
    icon_mb: "../../../../../assets/settings/account_mb.svg",
    listOfRow: [
      [
        { 
          label: "Customer", dataField: 'CustomerName', dataField1: 'CustomerAddress', 
          dataField2: 'CustomerContactPerson', dataField3: 'CustomerPhone', dataField4: 'CustomerEmail', 
          isBoldText: true, isContact: true, isColorContact: true, 
          isOrderCustomer: true, CustomerId: 'CustomerId' 
        },
        { 
          label: "Account Manager", dataField2: 'NewSalesPersonName', isContact: true, 
          isColorContact: true 
        },
        // dataField4: 'SalesPersonContactEmail', dataField3: 'SalesPersonContactPhone',
        { 
          label: "Reference Details", dataFieldSHIP: 'ReferenceNo', dataFieldSHIP1: 'ReferenceDate',
          dataFieldSHIP2: 'InvoiceNo', dataFieldSHIP3: 'TransportName', dataFieldSHIP4: 'orderInvoiceNumber',dataFieldSHIP5: 'CurrencyName',dataExchangeRate: 'ExchangeRate',
          isBoldText: true ,isShipmentOrderDetails:true,isExchangeRateInput:true,
          isInvoiceGenerate:'isInvoiceGenerate'
        }
      ],
      [
        { isAccordion: true, dataFieldA: 'InvoiceDue', dataFieldA1: 'PaymentResponsibility', dataFieldA2: 'CreditLimit' }
      ]
    ]
  }

  EmptypickDetails: any = {
    cardName: "Empty Yard",
    id: "EmptyPickDetails",
    icon_mb: "../../../../../assets/settings/account_mb.svg",
    isColorCFSYardCard: true,
    listOfRow: [
      [
        {
          label: "Yard/CFS", dataField: 'CSFYardContactPerson', dataField1: 'CFSYardCity',
          dataField2: 'EmptyPickAddress', isBoldText: true, isBoldCity: true
        },
      ],
      [
        { dataField2: 'CSFYardContactPerson', dataField3: 'CSFYardMobileNumber', dataField4: 'CSFYardEmail', isContact: true, isColorContact: true }
      ],
      [
        { label: "Yard Branch", dataField: 'PickupBranchName' }
      ],
      [
        { isHrLine: true }
      ],
      [
        { label: 'Expected time of departure', dataField: 'ExpectedDeparture' },
        { label1: 'Actual time of departure', dataField: 'ActualDeparture', valueType: 'IsActualArrival' }
      ],
      [
        {}, { dataField: 'HoursDifferencePickup', valueType: 'IsStatus', IsHoursDifference: true, IsPickup: true }
      ]
    ]
  }

  pickupDetails: any = {
    cardName: "PICKUP",
    id: "PickupDetails",
    icon_mb: "../../../../../assets/settings/account_mb.svg",
    isColorPickupCard: true,
    listOfRow: [
      [
        {
          label: "Shipper", dataField: 'PickUpContactPerson', dataField1: 'PickupCity',
          dataField2: 'PickupAddress', isBoldText: true, isBoldCity: true
        },
      ],
      [
        { dataField2: 'PickUpContactPerson', dataField3: 'PickUpContactNumber', dataField4: 'PickUpContactEmail', isContact: true, isColorContact: true }
      ],
      [
        { label: "Pickup Branch", dataField: 'PickUpBranchName' }
      ],
      [
        { isHrLine: true }
      ],
      [
        { label: 'Expected time of departure', dataField: 'ExpectedDeparture' },
        { label1: 'Actual time of departure', dataField: 'ActualDeparture', valueType: 'IsActualArrival' }
      ],
      [
        {}, { dataField: 'HoursDifferencePickup', valueType: 'IsStatus', IsHoursDifference: true, IsPickup: true }
      ]
    ]
  }

  deliveryDetails: any = {
    cardName: "DELIVERY",
    id: "DeliveryDetails",
    icon_mb: "../../../../../assets/settings/account_mb.svg",
    isColordeliveryCard: true,
    listOfRow: [
      [
        {
          label: "Consignee", dataField: 'DeliveryContactPerson', dataField1: 'DeliveryCity',
          dataField2: 'DeliveryAddress', isBoldText: true, isBoldCity: true
        },
      ],
      [
        { dataField2: 'DeliveryContactPerson', dataField3: 'DeliveryContactNumber', dataField4: 'DeliveryContactEmail', isContact: true, isColorContact: true }
      ],
      [
        { label: "Delivery Branch", dataField: 'DeliveryBranchName' }
      ],
      [
        { isHrLine: true }
      ],
      [
        { label: 'Expected time of arrival', dataField: 'ExpectedArrival' },
        { label1: 'Actual time of arrival', dataField: 'ActualArrival', valueType: 'IsActualArrival' }
      ],
      [
        {}, { dataField: 'HoursDifferenceDelivery', valueType: 'IsStatus', IsHoursDifference: true, IsDelivery: true }
      ]
    ]
  }

  productDetails: any = {
    cardName: 'Packages',
    id: "Product",
    icon_mb: "../../../../../assets/settings/organization_mb.svg",
    isTable: true,
    tableDetails: {
      data: [
      ],
      columnDetails: [
        { columnName: "Product", dataFieldName: 'ProductName', },
        { columnName: "Box/Pallet", dataFieldName: 'BoxPerPallet', alignType: 'right' },
        { columnName: "Qty", dataFieldName: 'Qty', alignType: 'right' },
        // { columnName: "Delivered", dataFieldName: 'Qty', isColorcolumn: true, headerColor: '#D2ECD0', bodyColor: '#EDF8EC', alignType: 'right' },
        // { columnName: "Pending", dataFieldName: 'Qty', isColorcolumn: true, headerColor: '#FBCDCD', bodyColor: '#FEEBEB', alignType: 'right' },
        { columnName: "Units", dataFieldName: 'UnitName', },
        { columnName: "Weight (Kgs)", dataFieldName: 'weight', alignType: 'right' },
        { columnName: "Dimention & CBM", dataFieldName: 'Dimention', dataFieldName2: 'CBM' },
        { columnName: "Invoice Amount", dataFieldName: 'InvoiceAmount', alignType: 'right' },
        { columnName: "Remarks", dataFieldName: 'Remarks', },
      ],
      isColumnNameShow: true,
    }
  }

  vehicleDetails: any = {
    cardName: 'Vehicle To Be Place',
    id: "Vehicle",
    icon_mb: "../../../../../assets/settings/organization_mb.svg",
    isTable: true,
    tableDetails: {
      data: [
      ],
      columnDetails: [
        // { columnName: "No", dataFieldName: 'Srno' },
        { columnName: "Type", dataFieldName: 'VehicleTypeName', },
        { columnName: "No. of Vehicle", dataFieldName: 'Qty', },
        // { columnName: "Placement Date", dataFieldName: 'PlacementDate', },
        { columnName: "Vehicle Specification", dataFieldName: 'Specifications', },
      ],
      isColumnNameShow: true,
    }
  }
  CompanyId: any;
  userId: any;
  @Input() PageTitle: any = '';
  tripDetails: any = {
    cardName: "",
    id: "TripDetails",
    icon_mb: "../../../../../assets/settings/account_mb.svg",
    listOfRow: [
      // [
      //   { Distance: 'Distance', ExpectedTravelTime: 'ExpectedTravelTime', isTravelingInfo: true, marginbottom: '30px' },
      //   { isPrintDropDownShow: true }
      // ],
      [
        { isOrigin: 'FTL', label: 'Origin Location', isLineHr: true, TransportService: 'TransportService' },
        // { isDestination: true, label: 'Destination Location', alignType: 'flex-end', isLineHr: true }
      ],
      [
        { PickupCity: 'PickupCity', PickupAddress: 'PickupAddress', dataField2: 'PickupDate' },
        { alignType: 'flex-end', DeliveryCity: 'DeliveryCity', DeliveryAddress: 'DeliveryAddress', dataField2: 'DeliveryDate' }
      ],
      [
        {
          IsTransporter: true, LogoPath: 'TransporterLogoPath', IsTransporterAuthorize: 'IsTransporterAuthorize',
          Transporter: 'Transporter', TransporterType: 'TransporterType',
          TransporterId: 'TransporterId', BookingId: 'BookingId'
        },
        {
          IsVehicle: true, VehicleNo: 'VehicleNo', IsVehicleAuthorized: 'IsVehicleAuthorized',
          VehicleDimention: 'VehicleDimention', vehicleCBM: 'vehicleCBM', vehicleWeight: 'vehicleWeight', cardVehicleType: 'cardVehicleType', cardSubVehicleType: 'cardSubVehicleType', BookingId: 'BookingId'
          , VehicleId: 'VehicleId', TotalVehicleWeight: 'TotalVehicleWeight', TotalTripProductWeight: 'TotalTripProductWeight', TotalProductCBM: 'TotalProductCBM'
        },
      ],
      [
        {
          IsDriver: true, IsDriverAuthorized: 'IsDriverAuthorized', DriverName: 'DriverName',
          LicenseExpiryDate: 'LicenseExpiryDate', DriverImage: 'DriverImage', DriverId: 'DriverId', BookingId: 'BookingId'
        },
        {
          IsPackages: true, IsDriverAuthorized: 'IsDriverAuthorized', TripPackages: 'TripPackages',
        },
        {
          isContainer: true, containerNo: 'containerNo', sealNo: 'sealNo',
        }
      ],
      [
        { IsTripStages: true }
      ]
    ]
  }
  stages: any = [];

  PrintNameList: any = [];
  @Input() OrderFrom: any = '';
  DocumentType: any;
  ActionMenuList: any = [];

  isFormSubmitY: boolean = false;
  
  Transporter: any = {
    lable: 'Transporter',
    formControlName: 'Transporter',
    dataField: 'Transporter',
    isRequired: true,
    placeholder: 'Select Transporter',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true
  };
  VehicleNo: any = {
    lable: 'VehicleNo',
    formControlName: 'VehicleNo',
    dataField: 'VehicleNo',
    isRequired: true,
    placeholder: 'Select Vehicle No',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true,
    addTag: true // Added by priya - 23/05/2026 - cn(PRIYA-MAY26-006)
  };
  Driver: any = {
    lable: 'Driver',
    formControlName: 'Driver',
    dataField: 'Driver',
    isRequired: true,
    placeholder: 'Select Driver',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true,
    addTag: true // Added by priya - 23/05/2026 - cn(PRIYA-MAY26-006)
  };
  DriverMobileNo = {
    lable: 'Driver Mobile No',
    formControlName: 'DriverMobileNo',
    dataField: 'DriverMobileNo',
    isRequired: true,
    placeholder: 'Enter Driver Mobile No',
  };
  DriverLicense = {
    lable: 'Driver License No',
    formControlName: 'DriverLicense',
    dataField: 'DriverLicense',
    placeholder: 'Enter Driver License No',
  };
  RCBookNo = {
    lable: 'RC Book No',
    formControlName: 'RCBookNo',
    dataField: 'RCBookNo',
    placeholder: 'Enter RC Book No',
  };
  ChassisNo = {
    lable: 'Chassis No',
    formControlName: 'ChassisNo',
    dataField: 'ChassisNo',
    placeholder: 'Enter Chassis No',
  };
  EngineNo = {
    lable: 'Engine No',
    formControlName: 'EngineNo',
    dataField: 'EngineNo',
    placeholder: 'Enter Engine No',
  };
  Reason: any = {
    lable: 'Change Reason',
    formControlName: 'Reason',
    dataField: 'Reason',
    isRequired: true,
    placeholder: 'Select Reason',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true
  };

  // for confirm delivery modal
  DeliveryStatus: any = {
    // lable: 'Delivery Status',
    formControlName: 'DeliveryStatus',
    dataField: 'DeliveryStatus',
    placeholder: 'Select here',
    typeOfField: 'dropdown',
    isValueBind: true
  };
  Damage: any = {
    formControlName: 'Damage',
    dataField: 'Damage',
    placeholder: 'Enter here',
    type: 'number'
  };
  Shortage: any = {
    formControlName: 'Shortage',
    dataField: 'Shortage',
    placeholder: 'Enter here',
    type: 'number'
  };
  SealShort: any = {
    formControlName: 'SealShort',
    dataField: 'SealShort',
    placeholder: 'Enter here',
    type: 'number'
  };
  Remark: any = {
    formControlName: 'Remark',
    dataField: 'Remark',
    placeholder: 'Enter here',
    type: 'text'
  };

  confirmDeliveryProductDetail: any = [];

  dataToSave: any;
  ConfirmDeliverydata: any = {};
  @ViewChild("popUpModal") popUpModal: TemplateRef<any>;
  @ViewChild("tripsMilestonemodal") tripsMilestonemodal: TemplateRef<any>;
  @ViewChild("PODUploadmodal") PODUploadmodal: TemplateRef<any>;
  @ViewChild("showPackagesModal") showPackagesModal: TemplateRef<any>;
  @ViewChild("showContainerPickupModal") showContainerPickupModal: TemplateRef<any>;
  @ViewChild("loadConfirmationModal") loadConfirmationModal: TemplateRef<any>;
  @ViewChild('ChangeHistory') ChangeHistory: TemplateRef<any>;
  @ViewChild('contentY') ChangeTransDrivVehiclcontentY: TemplateRef<any>;
  TenantId: any;
  mileStoneArray: any = []
  @Input() isActionMenuShow: boolean = false;
  tabTitle: any = '';
  AttachmenentUpload: boolean;
  @ViewChild(TransporterVehicleDriverCardModalComponent) TransporterVehicleDriverChild: TransporterVehicleDriverCardModalComponent;
  @ViewChild(FtlCostSheetComponent) FtlCostSheetComponentChild: FtlCostSheetComponent;
  @ViewChild('TransporterVehicleDriverCardModal') TransporterVehicleDriverCardModal: TemplateRef<any>;
  @ViewChild(QuotationlogComponent) QuotationlogChild: QuotationlogComponent;

  tripsProductList: ITableModel = {
    emptyDataMSg: "No Records Found",
    columnDetails: [
      { columnName: "Order No", dataFieldName: 'OrderNo', },
      { columnName: "Product", dataFieldName: 'ProductName', },
      { columnName: "Box/Pallet", dataFieldName: 'BoxPerPallet', alignType: 'right' },
      { columnName: "Qty", dataFieldName: 'Quantity', alignType: 'right' },
      { columnName: "Units", dataFieldName: 'UnitName', },
      { columnName: "Weight (Kgs)", dataFieldName: 'Weight', alignType: 'right' },
      { columnName: "CBM", dataFieldName: 'CBM' },
      { columnName: "Amount", dataFieldName: 'Amount', alignType: 'right' },
    ],
    data: [],
    footerData: [
      { OrderNo: 'Total', ProductName: '', BoxPerPallet: 0, Quantity: 0, UnitName: '', Weight: 0, CBM: 0, Amount: 0 },
    ],
    isColumnNameShow: true,
    isShowFooterData: true,
  };

  //Container Pickup Datafield
  containerNo: any = {
    lable: "Container No",
    formControlName: 'containerNo',
    dataField: 'containerNo',
    placeholder: 'Enter here',
    isRequired: true,
  };
  sealNo: any = {
    lable: "Seal No",
    formControlName: 'sealNo',
    dataField: 'sealNo',
    placeholder: 'Enter here',
    isRequired: true,
  };
  weight: any = {
    lable: "Weight (in Kgs)",
    formControlName: 'weight',
    dataField: 'weight',
    placeholder: 'Enter here',
    isRequired: true,
  };
  gateInTime = {
    lable: 'Gate In Date',
    formControlName: 'gateInTime',
    dataField: 'gateInTime',
    placeholder: 'Select Date',
    isTime: true,
  };
  gateOutTime = {
    lable: 'Gate Out Date',
    formControlName: 'gateOutTime',
    dataField: 'gateOutTime',
    placeholder: 'Select Date',
    isTime: true,
  };

  containerPickupData: any = {};
  isFormSubmit: boolean = false;

  consignmentProductList: any = [];
  consignmentProductTotalAmount: any;
  consignmentProductTotalBoxPerPallet: any;
  consignmentProductTotalQuantity: any;
  consignmentProductTotalWeight: any;

  loadConfirmationVehicleType: any;
  loadConfirmationSubVehicleType: any;
  loadConfirmationVehicleWeight: any;
  loadConfirmationVehicleCBM: any;

  //ConsignmentProduct Datefields
  Product: any = {
    lable: '',
    formControlName: 'Product',
    dataField: 'Product',
    isRequired: true,
    placeholder: 'Product Name',
    isSearchByApi: true,
    isValueBind: true
  };
  BoxPerPallet: any = {
    lable: '',
    formControlName: 'BoxPerPallet',
    dataField: 'BoxPerPallet',
    isRequired: false,
    placeholder: 'Box/Pallet',
    type: "number",
  };
  Quantity: any = {
    lable: '',
    formControlName: 'Quantity',
    dataField: 'Quantity',
    isRequired: true,
    placeholder: 'Quantity',
    type: "number",
  };
  Unit: any = {
    lable: '',
    formControlName: 'Unit',
    dataField: 'Unit',
    isRequired: true,
    placeholder: 'Unit',
    isSearchByApi: true,
    isValueBind: true
  };
  Weight: any = {
    lable: '',
    formControlName: 'Weight',
    dataField: 'Weight',
    isRequired: true,
    placeholder: 'Weight',
    type: "number",
  };
  Amount: any = {
    lable: '',
    formControlName: 'Amount',
    dataField: 'Amount',
    isRequired: false,
    placeholder: 'Amount',
    type: "number",
  };
  //End

  isLoadConfirmationModalOpen = false;
  consignmentProductCutomer: any;
  modalClosing = false;

  IndentId: any;
  OrderNo: any;

  newMileStoneArray: any = []
  TransVeheDriObj: any;
  isModalOpen: boolean = false;
  BookingIdForConsignmentProduct: any;
  IndentIdForConsignmentProduct: any;
  ConsignmentDetailIdForConsignmentProduct: any;
  // added by vithu 19-09-2025 - Siddarth
  InvoiceNo = {
    lable: 'Invoice No',
    formControlName: 'InvoiceNo',
    dataField: 'InvoiceNo',
    isRequired: false,
    placeholder: 'Enter Invoice No',
  };
  eWayBillNo = {
    lable: 'eWayBill No',
    formControlName: 'eWayBillNo',
    dataField: 'eWayBillNo',
    isRequired: false,
    type: 'number',
    maxlength: 12,
    placeholder: 'Enter eWayBill No',
  };
  InvoiceDate = {
    lable: 'Invoice Date',
    formControlName: 'InvoiceDate',
    dataField: 'InvoiceDate',
    placeholder: 'Select Invoice Date',
  };
  eWayBillExpDate = {
    lable: 'eWayBill Expiry Date',
    formControlName: 'eWayBillExpDate',
    dataField: 'eWayBillExpDate',
    placeholder: 'Select eWayBill Expiry Date',
  };
  // Added by priya - 03/02/2026 - cn(PRIYA-JAN26-016)
  IrnNo = {
    lable: 'IRN No',
    formControlName: 'IrnNo',
    dataField: 'IrnNo',
    isRequired: false,
    type: 'text',
    maxlength: 64,
    maxInputLength: 64, 
    placeholder: 'Enter IRN No',
  };
  // End by priya
  // Added by BURHAN - 22-April-2026
  LRNo = {
    lable: 'Manual LR Number',
    formControlName: 'LRNo',
    dataField: 'LRNo',
    isRequired: false,
    type: 'text',
    maxlength: 64,
    maxInputLength: 64, 
    placeholder: 'Enter Manual LR No.',
  };
  // End by BURHAN
  loadedData: any = {};
  selectedDropdownIndex: number | null = null;
  activeTabContext: 'DETAILS' | 'TRIPS' = 'DETAILS';
  @ViewChild(PrintFormatsNewComponent) PrintFormatsChild: PrintFormatsNewComponent;
  @ViewChild('sendEmailModal') sendEmailModal: TemplateRef<any>;
  LoadConfirmDateTime = {
    // lable: 'eWayBill Expiry Date',
    formControlName: 'LoadConfirmDateTime',
    dataField: 'LoadConfirmDateTime',
    placeholder: 'Select Date',
    isTime: true,
  };

  ConfirmLoadDate:any;
  // Added by priya - 22/01/2026 - cn(PRIYA-JAN26-013)
  ewayData: any = {} 
  IsVerifiedEway: boolean = false
  ULIPVerification: boolean = false
  EwayConsignmentList: any = [];
  VehicleNoForPartB: any;
  IsValidateEwayUlip: boolean = false;
  IsChangedTransDriVeh: boolean = false;
  TransporterGstIn: any;
  EwayData: any = [];
  ewayBillExpiryDays: any;
  EwayBillFiling: boolean = false;
  EwayBillNo: any;
  IsEwayPartBFiled: any;
  IsReachDestination: any;
  TransporterIdForEway: any;
  VehicleIdForEway: any;
  CompanyGSTIN: any;
  IsEwayBillNoExists: any;
  // End by priya
  // Added by priya - 03/02/2026 - cn(PRIYA-JAN26-016)
  modalEwayExtend: NgbModalRef | null = null;
  @ViewChild('ExtendEway') ExtendEway: TemplateRef<any>;
  EwayValidityData: any = {};
  isEwayFormSubmit: boolean = false;
  IsSimTracking: boolean = false; // Added by priya - 02/04/2026 - cn(PRIYA-APR26-001)
  ManualLRNumberOnOffFlag: boolean = false;//added by BURHAN - 22-April-2026
  EwayDistance = {
    lable: 'Remaining Distance',
    formControlName: 'EwayDistance',
    dataField: 'EwayDistance',
    isRequired: true,
    type: 'number',
    placeholder: 'Enter Remaining Distance',
  };
  EwayReason: any = {
    lable: 'Extend Validity Reason',
    formControlName: 'EwayReason',
    dataField: 'EwayReason',
    isRequired: true,
    placeholder: 'Select Reason',
    isSearchByApi: false,
    typeOfField: 'dropdown',
    isValueBind: true
  };
  EwayRemark = {
    lable: 'Extend Remark',
    formControlName: 'EwayRemark',
    dataField: 'EwayRemark',
    isRequired: true,
    type: 'textarea',
    placeholder: 'Enter Extend Remark',
  };
  // End by priya

  // added by yash 23/04/2026
  isNotesPanelOpen: boolean = false;
  notesTransactionType: string = '';
  notesTransactionId: string = '';
  // end by yash 23/04/2026

  @Input() selectedStatus:any;

  shipmentProductDetails: any = {
    cardName: 'Packages',
    id: "Product",
    icon_mb: "../../../../../assets/settings/organization_mb.svg",
    isTable: true,
    tableDetails: {
      columnDetails: [
        { columnName: "EAN Code", dataFieldName: "productUIValue", divType: "", width: "15%" },
        { columnName: "Case Size", dataFieldName: "caseSize", divType: "", alignType: "right", width: "11%" },
        { columnName: "Qty in Pcs", dataFieldName: "qty", divType: "", alignType: "right", width: "8%" },
        { columnName: "Fulfill Qty/Pc", dataFieldName: "fulFilledQty", divType: "", alignType: "right", width: "8%" },
        { columnName: "Balance Qty/Pc", dataFieldName: "balanceQty", divType: "", alignType: "right", width: "8%" },
        { columnName: "Qty in Cases", dataFieldName: "caseQty", divType: "", alignType: "right", width: "8%" },
        { columnName: "Mfg Date", dataFieldName: "mfgDate", divType: "", alignType: "right", width: "10%" },
        { columnName: "Exp Date", dataFieldName: "expDate", divType: "", alignType: "right", width: "10%" },
        { columnName: "MRP/Pc", dataFieldName: "MRP", divType: "", alignType: "right", width: "6%" },
        { columnName: "Rate/Pc", dataFieldName: "rate", divType: "", alignType: "right", width: "6%" },
        { columnName: "Amount", dataFieldName: "amount", divType: "", alignType: "right", width: "10%" },
        { columnName: "Sub Center", dataFieldName: 'FinalShiptoName', divType: '', width: '15%' },
        //{ columnName: "Actions",dataFieldName: '',dataFieldName2: 'IsEditRow',divType: 'UpdateAction',alignType: 'right',width: '10%'},
        
      ],
      data: [],
      footerData: [
        { productUIValue: 'Gross Total', caseSize: '', qty: 0, fulFilledQty: 0, balanceQty: 0, caseQty: '', MfgDate: "", ExpDate: "", MRP: '', rate: '', amount: 0.00 },
        { productUIValue: 'Discount', caseSize: '', qty: '', fulFilledQty: '', balanceQty: '', caseQty: '', MfgDate: "", ExpDate: "", MRP: '', rate: '', amount: 0.00 },
        // { productUIValue: 'Freight', caseSize: '', qty: '', fulFilledQty: '', balanceQty: '', caseQty: '', MfgDate: "", ExpDate: "", MRP: '', rate: '', amount: 0.00, },
        // { productUIValue: 'Insurance', caseSize: '', qty: '', fulFilledQty: '', balanceQty: '', caseQty: '', MfgDate: "", ExpDate: "", MRP: '', rate: '', amount: 0.00, },
        { productUIValue: 'Taxable Amount', caseSize: '', qty: '', fulFilledQty: '', balanceQty: '', caseQty: '', MfgDate: "", ExpDate: "", MRP: '', rate: '', amount: 0.00 },
        { productUIValue: "CGST", caseSize: "", qty: "", fulFilledQty: "", balanceQty: "", caseQty: "", MfgDate: "", ExpDate: "", MRP: '', rate: "", amount: 0.00 },
        { productUIValue: "SGST", caseSize: "", qty: "", fulFilledQty: "", balanceQty: "", caseQty: "", MfgDate: "", ExpDate: "", MRP: '', rate: "", amount: 0.00 },
        { productUIValue: "IGST", caseSize: "", qty: "", fulFilledQty: "", balanceQty: "", caseQty: "", MfgDate: "", ExpDate: "", MRP: '', rate: "", amount: 0.00 },
        { productUIValue: 'CESS', caseSize: '', qty: '', fulFilledQty: '', balanceQty: '', caseQty: '', MRP: '', rate: '', amount: 0.00 },
        { productUIValue: "Round off", caseSize: "", qty: "", fulFilledQty: "", balanceQty: "", caseQty: "", MfgDate: "", ExpDate: "", MRP: '', rate: "", amount: 0.00 },
        { productUIValue: "Net Amount", caseSize: "", qty: "", fulFilledQty: "", balanceQty: "", caseQty: "", MfgDate: "", ExpDate: "", MRP: '', rate: "", amount: 0.00 },
        { productUIValue: "Net Amount in Local Currency", caseSize: "", qty: "", fulFilledQty: "", balanceQty: "", caseQty: "", MfgDate: "", ExpDate: "", MRP: '', rate: "", amount: 0.00 },
      ],
      isColumnNameShow: true,
      isShowFooterData: true,
    }
  }

  portOfLoadingDetails: any = {
    cardName: "PORT OF LOADING",
    id: "PickupDetails",
    icon_mb: "../../../../../assets/settings/account_mb.svg",
    isColorPortOfLoading: true,
    listOfRow: [
      [
        {
          dataField: 'PortOfLoading',
        },
      ]
    ]
  }

  portOfDestinationDetails: any = {
    cardName: "PORT OF DESTINATION",
    id: "PickupDetails",
    icon_mb: "../../../../../assets/settings/account_mb.svg",
    isColorPortOfDestination: true,
    listOfRow: [
      [
        {
          dataField: 'PortOfDestination',
        },
      ]
    ]
  }

  portData:any={};
  SelectedCompanyGSTCode: any;

  shipmentInvoiceProductDetls: any = {
    cardName: '',
    id: "Product",
    icon_mb: "../../../../../assets/settings/organization_mb.svg",
    isTable: true,
    tableDetails: {
      columnDetails: [
        { columnName: "Order No", dataFieldName: "OrderNo", divType: "", width: "15%" },
        { columnName: "EAN Code", dataFieldName: "productUIValue", divType: "", width: "15%" },
        { columnName: "Case Size", dataFieldName: "caseSize", divType: "", alignType: "right", width: "11%" },
        { columnName: "Qty in Pcs", dataFieldName: "qty", divType: "", alignType: "right", width: "8%" },
        { columnName: "Fulfill Qty/Pc", dataFieldName: "fulFilledQty", divType: "", alignType: "right", width: "8%" },
        { columnName: "Balance Qty/Pc", dataFieldName: "balanceQty", divType: "", alignType: "right", width: "8%" },
        { columnName: "Qty in Cases", dataFieldName: "caseQty", divType: "", alignType: "right", width: "8%" },
        // { columnName: "Mfg Date", dataFieldName: "mfgDate", divType: "", alignType: "right", width: "10%" },
        // { columnName: "Exp Date", dataFieldName: "expDate", divType: "", alignType: "right", width: "10%" },
        { columnName: "MRP/Pc", dataFieldName: "MRP", divType: "", alignType: "right", width: "6%" },
        { columnName: "Client Rate", dataFieldName: "rate", divType: "", alignType: "right", width: "6%" },
        { columnName: "Custom Rate", dataFieldName: "CustomRate", divType: "", alignType: "right", width: "6%" },
        { columnName: "Client Amount", dataFieldName: "amount", divType: "", alignType: "right", width: "10%" },
        { columnName: "Custom Amount", dataFieldName: "CustomAmount", divType: "", alignType: "right", width: "10%" },
        { columnName: "Sub Center", dataFieldName: 'FinalShiptoName', divType: '', width: '15%' },
        { columnName: "Freight + Insurance USD", dataFieldName: 'TotalShippingCost', divType: '', width: '15%' },
        { columnName: "Total Purchase", dataFieldName: 'TotalPurchase', divType: '', width: '15%' },
        { columnName: "Total Sale", dataFieldName: 'TotalSale', divType: '', width: '15%' },
        { columnName: "Difference", dataFieldName: 'SalePurchaseDiff', divType: '', width: '15%' },
        { columnName: "Actions",dataFieldName: '',dataFieldName2: 'IsEditRow',divType: 'ShipmentUpdateAction',alignType: 'right',width: '10%'},
        
      ],
      data: [],
      footerData: [
        { OrderNo:'Gross Total', productUIValue: '', caseSize: '', qty: 0, fulFilledQty: 0, balanceQty: 0, caseQty: '', MfgDate: "", ExpDate: "", MRP: '', rate: '',CustomRate: '', amount: 0.00,CustomAmount: 0.00 ,FinalShiptoName:'',TotalPurchase:0.00,TotalSale:0.00,SalePurchaseDiff:0.00},
        { OrderNo:'Discount', productUIValue: '', caseSize: '', qty: '', fulFilledQty: '', balanceQty: '', caseQty: '', MfgDate: "", ExpDate: "", MRP: '', rate: '',CustomRate: '', amount: 0.00,CustomAmount: 0.00 },
        { OrderNo:'Freight', productUIValue: '', caseSize: '', qty: '', fulFilledQty: '', balanceQty: '', caseQty: '', MfgDate: "", ExpDate: "", MRP: '', rate: '',CustomRate: '', amount: 0.00,CustomAmount: 0.00 },
        { OrderNo:'Insurance', productUIValue: '', caseSize: '', qty: '', fulFilledQty: '', balanceQty: '', caseQty: '', MfgDate: "", ExpDate: "", MRP: '', rate: '',CustomRate: '', amount: 0.00,CustomAmount: 0.00},
        { OrderNo:'USD to AUD Ex-Rate', productUIValue: '', caseSize: '', qty: '', fulFilledQty: '', balanceQty: '', caseQty: '', MfgDate: "", ExpDate: "", MRP: '', rate: '',CustomRate: '', amount: 0.00,CustomAmount: 0.00, IsUSDtoAUD:true,divType:'number'},
        { OrderNo:'Taxable Amount', productUIValue: '', caseSize: '', qty: '', fulFilledQty: '', balanceQty: '', caseQty: '', MfgDate: "", ExpDate: "", MRP: '', rate: '',CustomRate: '', amount: 0.00,CustomAmount: 0.00 },
        { OrderNo:'CGST', productUIValue: "", caseSize: "", qty: "", fulFilledQty: "", balanceQty: "", caseQty: "", MfgDate: "", ExpDate: "", MRP: '', rate: "",CustomRate: '', amount: 0.00,CustomAmount: 0.00 },
        { OrderNo:'SGST', productUIValue: "", caseSize: "", qty: "", fulFilledQty: "", balanceQty: "", caseQty: "", MfgDate: "", ExpDate: "", MRP: '', rate: "",CustomRate: '', amount: 0.00,CustomAmount: 0.00 },
        { OrderNo:'IGST', productUIValue: "", caseSize: "", qty: "", fulFilledQty: "", balanceQty: "", caseQty: "", MfgDate: "", ExpDate: "", MRP: '', rate: "",CustomRate: '', amount: 0.00,CustomAmount: 0.00 },
        { OrderNo:'CESS', productUIValue: '', caseSize: '', qty: '', fulFilledQty: '', balanceQty: '', caseQty: '', MRP: '', rate: '',CustomRate: '', amount: 0.00,CustomAmount: 0.00 },
        { OrderNo:'Round off', productUIValue: "", caseSize: "", qty: "", fulFilledQty: "", balanceQty: "", caseQty: "", MfgDate: "", ExpDate: "", MRP: '', rate: "",CustomRate: '', amount: 0.00,CustomAmount: 0.00 },
        { OrderNo:'Net Amount', productUIValue: "", caseSize: "", qty: "", fulFilledQty: "", balanceQty: "", caseQty: "", MfgDate: "", ExpDate: "", MRP: '', rate: "",CustomRate: '', amount: 0.00,CustomAmount: 0.00 },
        { OrderNo:'Net Amount in Local Currency', productUIValue: "", caseSize: "", qty: "", fulFilledQty: "", balanceQty: "", caseQty: "", MfgDate: "", ExpDate: "", MRP: '', rate: "",CustomRate: '', amount: 0.00,CustomAmount: 0.00 },
      ],
      // actionList: [
      //   {label: 'Print Invoice Custom', icon: 'pi pi-print', visible: this.commonService.CheckHasRight('INVCUS', 'ORDER_LTL_DETAILS')},
      //   {label: 'Print Invoice Client Copy', icon: 'pi pi-print', visible: this.commonService.CheckHasRight('INVCLI', 'ORDER_LTL_DETAILS')},
      // ],
      isColumnNameShow: true,
      isShowFooterData: true,
    }
  }

  shipmentOrderInvoiceDetails: any = {
    cardName: "Invoice Header",
    id: "OrderDetails",
    icon_mb: "../../../../../assets/settings/account_mb.svg",
    listOfRow: [
      [
        { 
          label: "Customer", dataField: 'CustomerName', dataField1: 'CustomerAddress', 
          dataField2: 'CustomerContactPerson', dataField3: 'CustomerPhone', dataField4: 'CustomerEmail', 
          isBoldText: true, isContact: true, isColorContact: true, 
          isOrderCustomer: true, CustomerId: 'CustomerId' 
        },
        { 
          label: "Account Manager", dataField2: 'NewSalesPersonName', isContact: true, 
          isColorContact: true 
        },
        // dataField4: 'SalesPersonContactEmail', dataField3: 'SalesPersonContactPhone',
        { 
          label: "Reference Details", dataFieldSHIP: 'ReferenceNo', dataFieldSHIP1: 'ReferenceDate',
          dataFieldSHIP2: 'InvoiceNo', dataFieldSHIP3: 'TransportName', dataFieldSHIP4: 'orderInvoiceNumber',dataFieldSHIP5: 'CurrencyName',dataExchangeRate: 'ExchangeRate',
          isBoldText: true ,isShipmentOrderDetails:true,isExchangeRateInput:true,
          isInvoiceGenerate:'isInvoiceGenerate'
        }
      ],
      [
        { isAccordion: true, dataFieldA: 'InvoiceDue', dataFieldA1: 'PaymentResponsibility', dataFieldA2: 'CreditLimit' }
      ]
    ]
  }

  @Input() InvoiceNos: any;
  @Input() NewBookingId: any;

  invoiceactiveIndex: number = 0;

  shipmentInvoiceDiff: any = {
    cardName: '',
    id: "Product",
    icon_mb: "../../../../../assets/settings/organization_mb.svg",
    isTable: true,
    tableDetails: {
      columnDetails: [],
      data: [],
      footerData: [],
      // actionList: [
      //   {label: 'Print Invoice Custom', icon: 'pi pi-print', visible: this.commonService.CheckHasRight('INVCUS', 'ORDER_LTL_DETAILS')},
      //   {label: 'Print Invoice Client Copy', icon: 'pi pi-print', visible: this.commonService.CheckHasRight('INVCLI', 'ORDER_LTL_DETAILS')},
      // ],
      isColumnNameShow: true,
      isShowFooterData: true,
    }
  }

  IsFtlMarkedContainerPicked: boolean = false;

  constructor(private router: Router, private route: ActivatedRoute,
    private _appService: appService, private toastr: ToastrService,
    private cookieService: CookieService,
    private decryptpipe: DecryptPipe,
    private translate: TranslateService,
    private commonService: CommonService,
    private networkService: NetworkService,
    private userService: UserService,
    private _navService: NavService,
    private mobileDetectionService: MobileDetectionService,
    private modalService: NgbModal,
    private dp: DatePipe,
    private orderService: OrdersService,
    public datepipe: DatePipe,
    private cdr: ChangeDetectorRef,//added by BURHAN - 6-May-2026
    private Ulip: UlipService, // Added by priya - 22/01/2026 - Importing ulip service for using common function - cn(PRIYA-JAN26-013)
    private Eway: EwayBillService // Added by priya - 23/01/2026 - Importing ewaybill service for using common function - cn(PRIYA-JAN26-013)
  ) {
    TruckLoadViewComponent.that = this;
  }

  ngOnInit() {
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
    this.CompanyGSTIN = JSON.parse(localStorage.getItem('ChnageCompnayId')).SelectedCompantGSTIN;
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    this.hasEditAccess = this.commonService.CheckHasRight('EDIT', 'NETWORK_DETAILS');
    this.TenantId = JSON.parse(localStorage.getItem("ChnageCompnayId")).TenantId;
    this.SelectedCompanyGSTCode = JSON.parse(localStorage.getItem("ChnageCompnayId")).GSTCode;
    this.ManualLRNumberOnOffFlag = JSON.parse(localStorage.getItem("ManualLRNumberOnOffFlag"));//added by BURHAN - 22-April-2026
    this.LoadULIPVerification(); // Added by priya - 22/01/2026 - cn(PRIYA-JAN26-013)
    this.LoadEwayBillFiling(); // Added by priya - 28/01/2026 - cn(PRIYA-JAN26-014)
    this.LoadSimTracking(); // Added by priya - 02/04/2026 - cn(PRIYA-APR26-001)
    this.GetsystemSettingValueForCalculateTime(); // Added by priya - 23/06/2026 - cn(PRIYA-JUN26-007)
    this.LoadFtlMarkedContainerPicked(); // Added by priya - 27/07/2026 - cn(PRIYA-JUL26-016)
    this.GetPrintByCategory();
    this.LoadUseLeafletMap();
    this.LoadMakeToOrderAutoGeneratePO();
    console.log('screenname', this.ScreenName)
    if (this.ScreenName == 'FTL') {
      this.DocumentType = 'Full Truck Load';
    } else if (this.ScreenName == 'ContainerMovement') {
      this.DocumentType = 'ContainerMovement';
    } else if (this.ScreenName == 'LTL') {
      this.DocumentType = 'LTL Shipment';
    }
    console.log('this.DynamicServiceMode ngoninit', this.DynamicServiceMode, this.TransportService)

    if (this.ScreenName == 'ContainerMovement') {
      this.tripDetails.listOfRow[0][0].isOrigin = 'ContainerMovement';
      this.tripDetails.listOfRow[1].splice(0, 0, { CFSYardCity: 'CFSYardCity', yardAddress: 'yardAddress', });
      this.tripDetails.listOfRow[1][1] = {
        ...this.tripDetails.listOfRow[1][1],
        alignType: 'center'
      };
      this.tripDetails.listOfRow[2].splice(2, 0, {
        IsDriver: true, IsDriverAuthorized: 'IsDriverAuthorized', DriverName: 'DriverName',
        LicenseExpiryDate: 'LicenseExpiryDate', DriverImage: 'DriverImage', DriverId: 'DriverId'
      });

      this.tripDetails.listOfRow[3] = this.tripDetails.listOfRow[3].filter(item => !item.IsDriver);

      let firstTransportService = localStorage.getItem('firstTransportService')
      console.log('firstTransportService ngonit', firstTransportService)
      if (firstTransportService) {
        const service = firstTransportService.toLowerCase();
        if (service === 'import container') {
          this.EmptypickDetails.cardName = 'CFS/Port';
          this.pickupDetails.cardName = 'De-Stuff At';
          this.deliveryDetails.cardName = 'Return';
        } else if (service === 'export container') {
          this.EmptypickDetails.cardName = 'Empty Yard';
          this.pickupDetails.cardName = 'Stuffing At';
          this.deliveryDetails.cardName = 'CFS/Port';
        }
      }
    }

    if (this.ScreenName == 'NewTrips') {
      let ServiceName = localStorage.getItem('ServiceName')
      console.log('ServiceName ngonit', ServiceName)
      if (ServiceName == 'Export Container' || ServiceName == 'Import Container') {
        this.tripDetails.listOfRow[0][0].isOrigin = 'ContainerMovement';
        const isYardExists = this.tripDetails.listOfRow[1].some(function (item) {
          return item && item.CFSYardCity === 'CFSYardCity';
        });

        if (!isYardExists) {
          this.tripDetails.listOfRow[1].splice(0, 0, { CFSYardCity: 'CFSYardCity', yardAddress: 'yardAddress' });
        }

        if (this.tripDetails.listOfRow[1][1]) {
          this.tripDetails.listOfRow[1][1] = {
            ...this.tripDetails.listOfRow[1][1],
            alignType: 'center'
          };
        }
        var driverExists = false;
        for (var i = 0; i < this.tripDetails.listOfRow[2].length; i++) {
          if (this.tripDetails.listOfRow[2][i] && this.tripDetails.listOfRow[2][i].IsDriver === true) {
            driverExists = true;
            break;
          }
        }
        if (!driverExists) {
          this.tripDetails.listOfRow[2].splice(2, 0, {
            IsDriver: true,
            IsDriverAuthorized: 'IsDriverAuthorized',
            DriverName: 'DriverName',
            LicenseExpiryDate: 'LicenseExpiryDate',
            DriverImage: 'DriverImage',
            DriverId: 'DriverId'
          });
        }

        this.tripDetails.listOfRow[3] = this.tripDetails.listOfRow[3].filter(item => !item.IsDriver);

        const isContainerExists = this.tripDetails.listOfRow[3].some(function (item) {
          return item && item.isContainer === true;
        });

        if (!isContainerExists) {
          this.tripDetails.listOfRow[3].splice(1, 0, {
            isContainer: true, containerNo: 'containerNo', sealNo: 'sealNo',
          });
        }

      }
      localStorage.removeItem('ServiceName');

      this.data.Trips = [];
    }

    if (this.ScreenName == 'FTL' || this.ScreenName == 'LTL') {
      this.tripDetails.listOfRow[3].splice(2, 1);
    }

    if (this.ScreenName === 'NewTrips') {
      this.showTripPage = true;
    }

    this.GetIsAutoNumberingFlag();//added by BURHAN - 22-April-2026 - To print the manual LR no as per flag

    this.containerPickupData.gateInTime = this.datepipe.transform(new Date(), 'dd-MMM-yyyy HH:mm');
    this.containerPickupData.gateOutTime = this.datepipe.transform(new Date(), 'dd-MMM-yyyy HH:mm');
  }

  UseLeafletMap: boolean = false;
  LoadUseLeafletMap() {
    this._appService.GetById("Common", "GetSystemSettingByName", "UseLeafletMap").subscribe((response) => {
      if (response == '1') {
        this.UseLeafletMap = true;
      } else {
        this.UseLeafletMap = false;
      }
    },
      (err) => {
        this.toastr.error("Error occurred while fetching Status data !", "error");
      });
  }

  ngOnDestroy() {
    // localStorage.removeItem('FTLToEditPage');
  }

  onBackArrowCLick() {
    if (this.isAttachmentShow) {
      this.isAttachmentShow = false;
    } else {
      let route = localStorage.getItem('PrevRoute')
      if (this.ScreenName == 'LTL') {
        this.router.navigateByUrl(`/FtlList?Type=LTL`);
        // this.router.navigateByUrl(`/order_LTL`);
      } else if (this.ScreenName == 'FTL') {
        this.router.navigateByUrl(`/FtlList`);
      } else if (this.ScreenName == 'ContainerMovement') {
        this.router.navigateByUrl(`/Container-Movement`);
      } else if (this.ScreenName == 'NewTrips') {
        const FTLToEditPage = localStorage.getItem('BackToFTLPageUrl');

        if (FTLToEditPage) {
          const ftlData = JSON.parse(FTLToEditPage);
          localStorage.setItem('FTLToEditPage', JSON.stringify({
            id: ftlData.id,
            type: ftlData.type,
            searchValue: ftlData.searchValue
          }));
          localStorage.removeItem('BackToFTLPageUrl');
          this.router.navigateByUrl('FtlList/view');
        } else {
          this.router.navigateByUrl(`/New-Trips`);
        }
      } else if (this.ScreenName == 'Shipment') {
        this.router.navigateByUrl(`/order_LTL`);
      }
    }

  }

  ngAfterViewInit() {
  }

  goToEditPage() {
    if (this.ScreenName == 'FTL') {
      // localStorage.setItem('FTLToEditPage', JSON.stringify({
      //   id: this.SelectedId,
      //   type: 'FTL'
      // }));
      // this.router.navigateByUrl(`/FtlList/edit`);
      this.router.navigateByUrl(`/FtlList/edit/${this.SelectedId}?type=FTL`);
    } else if (this.ScreenName == 'ContainerMovement') {
      // localStorage.setItem('FTLToEditPage', JSON.stringify({
      //   id: this.SelectedId,
      //   type: 'ContainerMovement'
      // }));
      // this.router.navigateByUrl(`/Container-Movement/edit`);
      this.router.navigateByUrl(`/Container-Movement/edit/${this.SelectedId}?type=ContainerMovement`);
    } else if (this.ScreenName == 'LTL') {
      // localStorage.setItem('FTLToEditPage', JSON.stringify({
      //   id: this.SelectedId,
      //   type: 'LTL'
      // }));
      // this.router.navigateByUrl(`/FtlList/edit`);
      this.router.navigateByUrl(`/FtlList/edit/${this.SelectedId}?type=LTL`);

      // this.router.navigateByUrl(`/FtlList/edit/` + this.SelectedId + '?type=LTL');
    } else {
      this.router.navigateByUrl(`/FtlList/edit/${this.SelectedId}?type=FTL`);
    }
  }

  goToTrackPage() {
    if (this.ScreenName == 'FTL' || this.ScreenName == 'LTL') {
      window.open(`/Newtracking?id=` + this.SelectedId, '_blank');
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
    this.SelectedCompanyGSTCode = JSON.parse(localStorage.getItem("ChnageCompnayId")).GSTCode;
    this.ManualLRNumberOnOffFlag = JSON.parse(localStorage.getItem("ManualLRNumberOnOffFlag"));//added by BURHAN - 23-April-2026
    if (changes['SelectedId']) {
      this.SelectedId = changes['SelectedId'].currentValue;
      if (this.SelectedId) {
        if (this.ScreenName === 'NewTrips') {
          this.GetTripListById(this.SelectedId);
        } else {
          this.GetOrderVehicleById(this.SelectedId);
        }

        if (this.ScreenName === 'NewTrips') {
          if (this.data && this.data.Trips && this.data.Trips.length > 0) {
            this.activeIndex = 0;
          } else {
            this.activeIndex = 0;
          }
        }

        if (this.ScreenName === 'Shipment') {
          this.GetShipmentDataById(this.SelectedId);
        }
      }

      if (changes['DynamicServiceMode'] && changes['DynamicServiceMode'].currentValue !== undefined) {
        this.DynamicServiceMode = changes['DynamicServiceMode'].currentValue;

        this.tripDetails.listOfRow[1] = this.tripDetails.listOfRow[1].filter(function (item) {
          return !(item && item.CFSYardCity === 'CFSYardCity');
        });

        // Remove driver info if it exists
        this.tripDetails.listOfRow[2] = this.tripDetails.listOfRow[2].filter(function (item) {
          return !(item && item.IsDriver === true);
        });

        // Remove IsDriver from Row 3 if exists
        this.tripDetails.listOfRow[3] = this.tripDetails.listOfRow[3].filter(function (item) {
          return !(item && item.IsDriver === true);
        });

        this.tripDetails.listOfRow[1][1] = {
          ...this.tripDetails.listOfRow[1][1],
          alignType: 'flex-end'
        };

        console.log('this.DynamicServiceMode', this.DynamicServiceMode, this.TransportService)

        if (this.DynamicServiceMode == 'Export Container' || this.DynamicServiceMode == 'Import Container') {
          this.tripDetails.listOfRow[0][0].isOrigin = 'ContainerMovement';
          const isYardExists = this.tripDetails.listOfRow[1].some(function (item) {
            return item && item.CFSYardCity === 'CFSYardCity';
          });

          if (!isYardExists) {
            this.tripDetails.listOfRow[1].splice(0, 0, { CFSYardCity: 'CFSYardCity', yardAddress: 'yardAddress' });
          }

          if (this.tripDetails.listOfRow[1][1]) {
            this.tripDetails.listOfRow[1][1] = {
              ...this.tripDetails.listOfRow[1][1],
              alignType: 'center'
            };
          }
          var driverExists = false;
          for (var i = 0; i < this.tripDetails.listOfRow[2].length; i++) {
            if (this.tripDetails.listOfRow[2][i] && this.tripDetails.listOfRow[2][i].IsDriver === true) {
              driverExists = true;
              break;
            }
          }
          if (!driverExists) {
            this.tripDetails.listOfRow[2].splice(2, 0, {
              IsDriver: true,
              IsDriverAuthorized: 'IsDriverAuthorized',
              DriverName: 'DriverName',
              LicenseExpiryDate: 'LicenseExpiryDate',
              DriverImage: 'DriverImage',
              DriverId: 'DriverId'
            });
          }

          this.tripDetails.listOfRow[3] = this.tripDetails.listOfRow[3].filter(item => !item.IsDriver);

          const isContainerExists = this.tripDetails.listOfRow[3].some(function (item) {
            return item && item.isContainer === true;
          });

          if (!isContainerExists) {
            this.tripDetails.listOfRow[3].splice(1, 0, {
              isContainer: true, containerNo: 'containerNo', sealNo: 'sealNo',
            });
          }

        }

        if (this.DynamicServiceMode == 'FTL') {
          this.tripDetails.listOfRow[0][0].isOrigin = 'FTL';
          this.tripDetails.listOfRow[3].splice(0, 0, {
            IsDriver: true, IsDriverAuthorized: 'IsDriverAuthorized', DriverName: 'DriverName',
            LicenseExpiryDate: 'LicenseExpiryDate', DriverImage: 'DriverImage', DriverId: 'DriverId'
          });
          this.tripDetails.listOfRow[3].splice(2, 1);
          this.tripDetails.listOfRow[1][0] = {
            ...this.tripDetails.listOfRow[1][0],
            alignType: 'flex-start'
          };
        }

        this.GetIsAutoNumberingFlag();//added by BURHAN - 22-April-2026 - To print the manual LR no as per flag

      }

      if (changes['SelectedTransportService']) {
        this.SelectedTransportService = changes['SelectedTransportService'].currentValue;

        if (this.ScreenName === 'ContainerMovement' && this.SelectedTransportService) {
          const service = this.SelectedTransportService.toLowerCase();
          if (service === 'import container') {
            this.EmptypickDetails.cardName = 'CFS/Port';
            this.pickupDetails.cardName = 'De-Stuff At';
            this.deliveryDetails.cardName = 'Return';
          } else if (service === 'export container') {
            this.EmptypickDetails.cardName = 'Empty Yard';
            this.pickupDetails.cardName = 'Stuffing At';
            this.deliveryDetails.cardName = 'CFS/Port';
          }
        }
        console.log('SelectedTransportService:', this.SelectedTransportService);
        if (this.ScreenName === 'ContainerMovement' && this.SelectedTransportService) {
          this.changeContainerActions();
        }
      }
    }
    if (changes['InvoiceNos'] && changes['InvoiceNos'].currentValue !== undefined) {
      this.InvoiceNos = changes['InvoiceNos'].currentValue;
      this.GetShipmentInvoiceDataById();
      this.GetshipmentInvoiceDiff();
    }
  }

  GetOrderVehicleById(OrderId) {

    Helpers.setLoading(true);
    this._appService.GetByTwoId("OrdersByVehicle", "GetOrderVehicleById", OrderId, this.CompanyId).subscribe((response) => {
      this.data.Order = response;
      this.data.Order.Distance = response.Distance ? `${response.Distance.toFixed(2)} km` : 0;
      this.data.Products = response.ProductList;
      this.productDetails.tableDetails.data = this.data.Products;
      this.productDetails.tableDetails.data.forEach(element => {
        element.CBM = element.CBM.toString();
        element.InvoiceAmount = element.InvoiceAmount ? element.InvoiceAmount.toFixed(2) : 0.00;
      });

      this.data.BookingId = response.BookingId;
      this.data.TransporterId = response.Transporter;
      this.data.Transporter = response.TransporterName;
      this.data.cardVehicleType = response.cardVehicleType;
      this.data.VehicleType = response.VehicleTypeId;

      this.data.Vehicles = response.VehicleList;
      // Added by priya - 23/06/2026 - cn(PRIYA-JUN26-007)
      this.vehicleDetails.tableDetails.data = this.data.Vehicles.map((v: any) => {
          return {
            ...v,
            DistanceTime: `${v.Distance} | ${v.TravelTime}`,
          };
      });
      if (this.IsCalculateTravelTimeByVehicleKm && !this.vehicleDetails.tableDetails.columnDetails.some(
          c => c.dataFieldName === 'DistanceTime')
      ) {
        this.vehicleDetails.tableDetails.columnDetails.push({
          columnName: 'Distance & Travel Time', dataFieldName: 'DistanceTime'
        });
      }
      // this.vehicleDetails.tableDetails.data = this.data.Vehicles;
      // End by priya
      this.data.Order.ReferenceDate = this.data.Order.ReferenceDate ? this.dp.transform(this.data.Order.ReferenceDate, 'dd-MMM-yyyy HH:mm') : null;
      this.data.OriginAddress = this.data.Order.PickupAddress + "," + this.data.Order.PickupCity + "," + this.data.Order.PickupState + ","
        + this.data.Order.PickupCountry;

      this.data.DestinationAddress = this.data.Order.DeliveryAddress + "," + this.data.Order.DeliveryCity + "," + this.data.Order.DeliveryState
        + "," + this.data.Order.DeliveryCountry;

      this.data.EmptyPickAddress = this.data.Order.EmptyPickAddress;
      if (this.data.Order.PickUpLatitude == null || this.data.Order.PickUpLatitude == 0 || this.data.Order.PickUpLongtitude == null || this.data.Order.PickUpLongtitude == 0) {
        // this.getLatLng(this.data.OriginAddress, 'Origin');
      }
      if (this.data.Order.DeliverLatitude == null || this.data.Order.DeliverLatitude == 0 || this.data.Order.DeliverLongtitude == null || this.data.Order.DeliverLongtitude == 0) {
        // this.getLatLng(this.data.DestinationAddress, 'Destination');
      }
      if (this.ScreenName == 'ContainerMovement') {
        if (this.data.Order.CFSYARDLocationLatitude == null || this.data.Order.CFSYARDLocationLatitude == 0 || this.data.Order.CFSYARDLocationLongtitude == null || this.data.Order.CFSYARDLocationLongtitude == 0) {
          // this.getLatLng(this.data.EmptyPickAddress, 'CFSYARDLocation');
        }
      }
      this.WayPoints = [];
      this.data.Trips = response.TripList;
      // this.data.Trips.Distance = `${response.TripList.Distance.toFixed(2)} km`;
      this.data.Trips.forEach(element => {
        // var stageList: any = [];
        // this.stages.forEach(ele => {
        //   var obj: any = {};
        //   obj.id = ele.id;
        //   obj.label = ele.label;

        //   var date: any = null;
        //   var time: any = null;
        //   var completed: any = false;
        //   switch (ele.id) {
        //     case 1:
        //       date = element.PlacementDate;
        //       time = element.PlacementTime;
        //       completed = element.PlacementDate ? true : false;
        //       break;
        //     case 2:
        //       // date = element.OriginArrivedDate;
        //       // time = element.OriginArrivedTime;
        //       // completed = element.OriginArrivedDate ? true : false;

        //       // Edited by fahim 
        //       date = element.OriginArrivedDate || element.OriginGateInDate;
        //       time = element.OriginArrivedTime || element.OriginGateInTime;
        //       completed = date ? true : false;
        //       break;
        //     case 3:
        //       date = element.OriginGateInDate;
        //       time = element.OriginGateInTime;
        //       completed = element.OriginGateInDate ? true : false;
        //       break;
        //     case 4:
        //       date = element.PickedDate;
        //       time = element.PickedTime;
        //       completed = element.PickedDate ? true : false;
        //       break;
        //     case 5:
        //       date = element.OriginGateOutDate;
        //       time = element.OriginGateOutTime;
        //       completed = element.OriginGateOutDate ? true : false;
        //       break;
        //     case 6:
        //       date = element.DestinationArrivedDate;
        //       time = element.DestinationArrivedTime;
        //       completed = element.DestinationArrivedDate ? true : false;
        //       break;
        //     case 7:
        //       date = element.DestinationGateInDate;
        //       time = element.DestinationGateInTime;
        //       completed = element.DestinationGateInDate ? true : false;
        //       break;
        //     case 8:
        //       date = element.DestinationGateOutDate;
        //       time = element.DestinationGateOutTime;
        //       completed = element.DestinationGateOutDate ? true : false;
        //       break;
        //     case 9:
        //       date = element.ProofofDeliveryDate;
        //       time = element.ProofofDeliveryTime;
        //       completed = element.ProofofDeliveryDate ? true : false;
        //       break;
        //     case 10:
        //       date = element.PODReceivedDate;
        //       time = element.PODReceivedTime;
        //       completed = element.PODReceivedDate ? true : false;
        //       break;
        //     default:
        //       break;
        //   }

        //   obj.date = date;
        //   obj.time = time;
        //   obj.completed = completed;
        //   stageList.push(obj);
        // });
        // element.Stages = stageList;
        let MilestoneArr = [];
        MilestoneArr = JSON.parse(element.mileStoneList);

        this.stages = MilestoneArr.map((item: any, index: number) => {
          const actualDate = item.ActualDate || null;
          const time = item.ActualTime || null;

          return {
            id: index + 1,
            label: item.stageName || '',
            date: actualDate,
            time: time,
            completed: !!item.ActualDate  // true if ActualDate exists
          };
        });

        element.Stages = this.stages;

        var obj: any = {};
        obj.location = element.DeliveryAddress;
        obj.tripNo = element.ConsignmentNo;
        obj.lat = element.lat;
        obj.lng = element.lng;
        obj.VehicleNo = element.VehicleNo;
        obj.VehicleType = element.VehicleType;
        this.WayPoints.push(obj);

        if (!this.UseLeafletMap) {
          this.calculateTravelDistanceAndTime(element.PickupAddress, element.DeliveryAddress).then((result) => {
            element.Distance = result.distanceInKm;  // Update with the distance in km
            element.ExpectedTravelTime = result.durationInHours;  // Update with the duration in hours
          }).catch((error) => {
            console.error("Error calculating travel data: ", error);
          });
        }
      });

      this.YardAddress = response.yardAddress.replace(/<br>/g, ' ');
      // this.TransportService = response.TripList[0].TransportService;
      this.TransportService = (response.TripList && response.TripList.length > 0) ? response.TripList[0].TransportService : null;
      // this.EmptypickDetails.listOfRow[0][0].dataField2 = this.YardAddress;
      // this.getMileStoneList();
      this.switchTab(null);
      Helpers.setLoading(false);
      if (this.data.Trips && this.data.Trips.length > 0) {
        this.showTripPage = true;
      } else {
        this.showTripPage = false;
        this.activeIndex = 0;
      }
    },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
        Helpers.setLoading(false);
      }
    );
  }
  WayPoints: any = [];

  async getLatLng(address: string, from: string) {
    // const geocoder = new google.maps.Geocoder();
    // geocoder.geocode({ address: address }, (results, status) => {
    //   if (status === "OK") {
    //     const location = results[0].geometry.location;
    //     if (from === "Origin") {
    //       this.data.Order.PickUpLatitude = location.lat();
    //       this.data.Order.PickUpLongtitude = location.lng();
    //     }
    //     if (from === "Destination") {
    //       this.data.Order.DeliverLatitude = location.lat();
    //       this.data.Order.DeliverLongtitude = location.lng();
    //     }
    //     if (this.ScreenName == 'ContainerMovement') {
    //       if (from === "CFSYARDLocation") {
    //         this.data.Order.CFSYARDLocationLatitude = location.lat();
    //         this.data.Order.CFSYARDLocationLongtitude = location.lng();
    //       }
    //     }
    //   } else {
    //     console.log("Geocode was not successful for the following reason: " + status);
    //   }
    // });

    const [latLongs] = await Promise.all([
      this.getCoordinatesFromAddress(address),
    ]);

    if (from === "Origin") {
      this.data.Order.PickUpLatitude = latLongs[0];
      this.data.Order.PickUpLongtitude = latLongs[1];
    }
    if (from === "Destination") {
      this.data.Order.DeliverLatitude = latLongs[0];
      this.data.Order.DeliverLongtitude = latLongs[1];
    }
    if (this.ScreenName == 'ContainerMovement') {
      if (from === "CFSYARDLocation") {
        this.data.Order.CFSYARDLocationLatitude = latLongs[0];
        this.data.Order.CFSYARDLocationLongtitude = latLongs[1];
      }
    }
  }

  //added by vithu 28-04-2025
  // getCoordinatesFromAddress(address: string): Promise<[number, number, number]> {
  //   const cleanedAddress = address.replace(/-/g, ',').replace(/\d{6}$/, '').replace(/,\s*$/, '');
  //   const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(cleanedAddress)}`;

  //   return fetch(url, {
  //     headers: {
  //       'Accept-Language': 'en',
  //       'User-Agent': 'YourAppName/1.0 (youremail@example.com)' // Replace with real app name/email
  //     }
  //   })
  //     .then(response => {
  //       if (!response.ok) {
  //         throw new Error('Failed to fetch coordinates');
  //       }
  //       return response.json();
  //     })
  //     .then(data => {
  //       if (data && data.length > 0) {
  //         const { lat, lon } = data[0];
  //         return [parseFloat(lat), parseFloat(lon), 0] as [number, number, number];
  //       } else {
  //         // If using Toastr in Angular or similar
  //         if (typeof this !== 'undefined' && this.toastr) {
  //           this.toastr.error('Address not found!', 'Error');
  //         }
  //         throw new Error('Address not found');
  //       }
  //     });
  // }

  GetMapData(event) {
    this.data.Order.Distance = event.distance;
    this.data.Order.ExpectedTravelTime = event.duration;
  }

  calculateTravelDistanceAndTime(origin: any, destination: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      const directionsService = new google.maps.DirectionsService();

      directionsService.route({
        origin: origin,
        destination: destination,
        travelMode: google.maps.TravelMode.DRIVING,  // Adjust this based on your mode
      }, (response, status) => {
        if (status === "OK") {
          const route = response.routes[0];
          let totalDistance = 0;
          let totalDuration = 0;

          route.legs.forEach((leg) => {
            totalDistance += leg.distance.value;  // Distance in meters
            totalDuration += leg.duration.value;  // Duration in seconds
          });

          // Convert distance to kilometers
          const distanceInKm = (totalDistance / 1000).toFixed(2);  // km

          // Convert duration to hours
          const durationInHours = (totalDuration / 3600).toFixed(2);  // hours

          // Resolve the promise with the calculated data
          resolve({
            distanceInKm: distanceInKm,
            durationInHours: durationInHours
          });
        } else {
          reject("Directions request failed due to " + status);
        }
      });
    });
  }

  GetPrintByCategory() {
    this.ActionMenuList = [];
    this.PrintNameList = [];
    this.ActionMenuList.push({ PrintName: 'Edit' });
    if(
      this.data &&
      this.data.Order &&
      this.data.Order.OrderStatus &&
      this.data.Order.OrderStatus === 'Pending' &&
      this.ScreenName !== 'NewTrips'
    ){
      this.ActionMenuList.push({ PrintName: 'Ship Now' });
    }
    this.ActionMenuList.push({ PrintName: 'Attachments' });
    this.ActionMenuList.push({ PrintName: 'Delete' });

    this._appService.GetByOneParam('Lookup', 'GetPrintByCategory', 'LRPrint').subscribe(
      (response) => {
        const visibleItems = response.filter(item => item.isVisible === true);
        visibleItems.forEach(element => {

          const alreadyExists = this.ActionMenuList.some(e => e.PrintName === element.PrintName);
          if (!alreadyExists) {
            if (element.PrintName === 'Trip Expense' && (this.tabTitle == 'Trips' || this.ScreenName == 'NewTrips')) {
              this.ActionMenuList.push(element);
            }
            if (element.PrintName === 'Record Income' && (this.tabTitle != 'Trips' && this.ScreenName != 'NewTrips')) {
              this.ActionMenuList.push(element);
            }
          }

          if (this.ScreenName === 'FTL' || this.ScreenName === 'LTL') {
            const desiredOrder = [
              'Print Lorry Receipt',
              'Mark As Loaded',
              'Mark As Delivered',
              'Update Tracking Status',
              'Track',  
              'Change Transporter, Driver & Vehicle',
              'Change History',
              'Record Income',
              'Trip Expense',
              'Notes' // added by yash 04-05-2026
            ];

            let ftlItems = visibleItems.filter(item => desiredOrder.includes(item.PrintName));

            ftlItems = ftlItems.sort((a, b) => {
              return desiredOrder.indexOf(a.PrintName) - desiredOrder.indexOf(b.PrintName);
            });

            this.PrintNameList = ftlItems.filter((item, index, self) =>
              index === self.findIndex(t => t.PrintName === item.PrintName && t.Code === item.Code)
            );

          } else if (this.ScreenName === 'ContainerMovement') {
            const desiredOrder = [
              'Track',
              'Print Lorry Receipt',
              'Mark As Container Picked',
              'Mark As Loaded',
              'Mark As Delivered',
              'Update Tracking Status',
              'Change Transporter, Driver & Vehicle',
              'Change History',
              'Record Income',
              'Trip Expense',
              'Notes' // added by yash 04-05-2026
            ];

            const service = this.SelectedTransportService.toLowerCase();
            let insertItem = service === 'import container' ? 'Mark As De-Stuffed' : 'Mark As Stuffed';

            const loadedIndex = desiredOrder.indexOf('Mark As Loaded');
            if (loadedIndex !== -1) {
              desiredOrder[loadedIndex] = insertItem;
            }

            const alreadyInVisible = visibleItems.some(item => item.PrintName === insertItem);
            if (!alreadyInVisible) {
              visibleItems.push({
                PrintName: insertItem,
                Code: '8',
                CategoryName: 'LRPrint',
                isVisible: true
              });
            }

            let ftlItems = visibleItems.filter(item => desiredOrder.includes(item.PrintName));

            ftlItems = ftlItems.sort((a, b) => {
              return desiredOrder.indexOf(a.PrintName) - desiredOrder.indexOf(b.PrintName);
            });

            this.PrintNameList = ftlItems.filter((item, index, self) =>
              index === self.findIndex(t => t.PrintName === item.PrintName && t.Code === item.Code)
            );

          } else {
            const desiredOrder = [
              'Print Lorry Receipt',
              'Mark As Loaded',
              'Mark As Delivered',
              'Update Tracking Status',
              'Track',
              'Change Transporter, Driver & Vehicle',
              'Change History',
              'Record Income',
              'Trip Expense'
            ];

            let ftlItems = visibleItems.filter(item => desiredOrder.includes(item.PrintName));

            ftlItems = ftlItems.sort((a, b) => {
              return desiredOrder.indexOf(a.PrintName) - desiredOrder.indexOf(b.PrintName);
            });

            this.PrintNameList = ftlItems.filter((item, index, self) =>
              index === self.findIndex(t => t.PrintName === item.PrintName && t.Code === item.Code)
            );

          }
        });


      },
      (err) => {
        this.toastr.error("Error while fetching print names", "error");
      }
    );
  }

  isDropdownOpen: boolean = false;
  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  onSelectItem(item: any, row: any) {
    if (item.PrintName === 'Trip Expense') {
      this.TransporterId = this.data.TransporterId;
      this.BookingId = this.data.BookingId;
      this.TransporterName = this.data.Transporter;
      this.VehicleType = this.data.VehicleTypeId; // Added by priya - 09/06/2026 - cn(PRIYA-JUN26-002)
      this.cardVehicleType = this.data.cardVehicleType; // Added by priya - 09/06/2026 - cn(PRIYA-JUN26-002)
      this.modalRef = this.modalService.open(this.tripExpense, { centered: true, size: "lg", windowClass: "modal-xl-custom" });
    } else if (item.PrintName == 'Record Income') {
      this.modalRefRI = this.modalService.open(this.recordIncome, { centered: true, size: "lg", windowClass: "modal-xl-custom" });
    } else if (item.PrintName.trim() == 'Edit') {
      this.goToEditPage();
    } else if (item.PrintName.trim() == 'Ship Now') {
      this.GotoShipNow();
    } else if (item.PrintName.trim() == 'Attachments') {
      this.isAttachmentShow = true
    } else if (item.PrintName.trim() == 'Delete') {
      this.obv_deleteOrder()
    }
  }

   onSelectItemNew(event: any, row: any) {
    let PrintName = event.target.innerText ? event.target.innerText : event;
    if (PrintName === 'Trip Expense') {
      this.TransporterId = this.data.TransporterId;
      this.BookingId = this.data.BookingId;
      this.TransporterName = this.data.Transporter;
      this.VehicleType = this.data.VehicleTypeId; // Added by priya - 09/06/2026 - cn(PRIYA-JUN26-002)
      this.cardVehicleType = this.data.cardVehicleType; // Added by priya - 09/06/2026 - cn(PRIYA-JUN26-002)
      this.modalRef = this.modalService.open(this.tripExpense, { centered: true, size: "lg", windowClass: "modal-xl-custom" });
    } else if (PrintName == 'Record Income') {
      this.modalRefRI = this.modalService.open(this.recordIncome, { centered: true, size: "lg", windowClass: "modal-xl-custom" });
    } else if (PrintName.trim() == 'Edit') {
      this.goToEditPage();
    } else if (PrintName.trim() == 'Ship Now') {
      this.GotoShipNow();
    } else if (PrintName.trim() == 'Attachments') {
      this.isAttachmentShow = true
    } else if (PrintName.trim() == 'Delete') {
      this.obv_deleteOrder()
    } else if(PrintName.trim() == 'Print Quote'){
      this.PrintQuote();
    } else if(PrintName.trim() == 'Mail Quote') {
      // if(row.RecordIncAmt === null || row.RecordIncAmt === ''){
      //   this.toastr.warning('Please record the income','warning');
      //   return;
      // }
      this.modalRef = this.modalService.open(this.sendEmailModal, {centered: true, size: 'lg'});
    }
    // added by yash 23/04/2026
    else if (PrintName.trim() == 'Notes') {
      this.openNotesPanel();
      return;
    }
    // end by yash 23/04/2026
  }

  // added by yash 29-05-2026
  openNotesPanel() {

  if (!this.data || !this.data.Order || !this.data.Order.Id) {
    this.toastr.warning('Order details not loaded.');
    return;
  }

  if (this.ScreenName === 'FTL') {
    this.notesTransactionType = 'FTL Point To Point';
  }
  else if (this.ScreenName === 'ContainerMovement') {
    this.notesTransactionType = 'FTL Container Movement';
  }
  else if (this.ScreenName === 'LTL') {
    this.notesTransactionType = 'LTL Shipment';
  }
  else if (this.ScreenName === 'Shipment') {
    this.notesTransactionType = 'Shipment';
  }

  this.notesTransactionId = this.data.Order.Id;

  this.isNotesPanelOpen = false;

  setTimeout(() => {
    this.isNotesPanelOpen = true;
  }, 0);

  console.log('Notes Type:', this.notesTransactionType);
  console.log('Notes Id:', this.notesTransactionId);
}

  @ViewChild("tripExpense") tripExpense: TemplateRef<any>;
  THCId: any = null;
  TransporterId: any = null;
  BookingId: any = null;
  TransporterName: any = null;
  VehicleType: any = null; // Added by priya - 09/06/2026 - cn(PRIYA-JUN26-002)
  cardVehicleType: any = null; // Added by priya - 09/06/2026 - cn(PRIYA-JUN26-002)
  closeModalTripExpense() {
    this.modalRef.close();
  }

  modalRefRI: NgbModalRef | null = null;
  @ViewChild("recordIncome") recordIncome: TemplateRef<any>;
  closeModalRI() {
    this.modalRefRI.close();
    this.onCostSheetRefresh();
  }

  GetTripListById(BookingId) {
    this._appService.GetByTwoId("Booking", "GetTripListById", BookingId, this.CompanyId).subscribe(
      (response) => {
        this.WayPoints = [];
        if (response.length !== 0) {
          this.data = response[0];
          this.data.OriginAddress = response[0].PickupAddress;
          this.data.DestinationAddress = response[0].DeliveryAddress;
          this.data.BookingId = response[0].BookingId;
          this.data.TransporterId = response[0].TransporterId;
          this.data.Transporter = response[0].Transporter;
          this.data.IndentId = response[0].IndentId;
          this.data.Customer = response[0].CustomerId;
          this.data.OrderNo = response[0].OrderNo;
          this.data.OrderStatus = response[0].BookingStatus || 'Assigned Vehicles';

          response.map((x) => {

            if (x.LogoPath) {
              if (x.LogoPath.startsWith('../../Document/Logos/.')) {
                x.LogoPath = null;
              } else {
                x.LogoPath = environment.apiUrl + "/" + x.LogoPath;
              }
            }

          });

          if (this.data.PickUpLatitude == null || this.data.PickUpLatitude == 0 || this.data.PickUpLongtitude == null || this.data.PickUpLongtitude == 0) {
            // var coordinates = this.getCoordinatesFromAddress(this.data.OriginAddress);
            // this.getLatLng(this.data.OriginAddress, 'Origin');
          }
          if (this.data.DeliverLatitude == null || this.data.DeliverLatitude == 0 || this.data.DeliverLongtitude == null || this.data.DeliverLongtitude == 0) {
            // var coordinates = this.getCoordinatesFromAddress(this.data.DestinationAddress);
            // this.getLatLng(this.data.DestinationAddress, 'Destination');
          }
          this.data.Trips = response;
          this.data.Trips.forEach(element => {
            let MilestoneArr = [];
            MilestoneArr = JSON.parse(element.mileStoneList);

            this.stages = MilestoneArr.map((item: any, index: number) => {
              const actualDate = item.ActualDate || null;
              const time = item.ActualTime || null;

              return {
                id: index + 1,
                label: item.stageName || '',
                date: actualDate,
                time: time,
                completed: !!item.ActualDate  // true if ActualDate exists
              };
            });

            element.Stages = this.stages;

            var obj: any = {};
            obj.location = element.DeliveryAddress;
            obj.tripNo = element.ConsignmentNo;
            obj.lat = element.lat;
            obj.lng = element.lng;
            obj.VehicleNo = element.VehileNo;
            obj.VehicleType = element.VehicleType;
            this.WayPoints.push(obj);

            this.TransportService = response && response[0].TransportService ? response[0].TransportService : null;
            this.activeIndex = 0;
            if (!this.UseLeafletMap) {
              this.calculateTravelDistanceAndTime(element.PickupAddress, element.DeliveryAddress).then((result) => {
                element.Distance = result.distanceInKm;  // Update with the distance in km
                element.ExpectedTravelTime = result.durationInHours;  // Update with the duration in hours
              }).catch((error) => {
                console.error("Error calculating travel data: ", error);
              });
            }
          });
        }

      },
      (err) => {

      }
    );
  }

  getCoordinatesFromAddress(address: string): Promise<[number, number, number]> {
    return new Promise((resolve, reject) => {
      var obj: any = {};
      obj.address = address;
      this._appService.Post('OrdersByVehicle', 'GetCoordinatesFromAddressAsync', obj).subscribe(
        (response: any) => {
          // Assuming response has 'Latitude', 'Longitude', 'Altitude'
          if (response) {
            const lat: number = response.Latitude;
            const lon: number = response.Longitude;
            const alt: number = response.Altitude || 0; // Default to 0 if Altitude is not provided

            resolve([lat, lon, alt]);
          } else {
            this.toastr.error('Address not found!');
            reject('Address not found');
          }
        },
        error => {
          this.toastr.error('Error fetching coordinates!');
          reject('Error fetching coordinates');
        }
      );
    });
  }

  changeDriverTransporterModal(event) {
    if (this.isModalOpen) return; // Prevent duplicate open

    this.isModalOpen = true;
    let obj: any = {};
    obj.TransporterId = event.TransporterId !== undefined ? event.TransporterId : null;
    obj.DriverId = event.DriverId !== undefined ? event.DriverId : null;
    obj.VehicleId = event.VehicleId !== undefined ? event.VehicleId : null;
    obj.userId = this.userId;
    obj.CompanyId = this.CompanyId;
    obj.Type = event.type;
    obj.BookingId = event.BookingId;

    this.TransVeheDriObj = obj;

    this.modalRef = this.modalService.open(this.TransporterVehicleDriverCardModal, { centered: true, size: "lg" });
    // this.TransporterVehicleDriverChild.getTransporterVehicleDriver(obj);
    // this.modalRef = this.modalService.open(TransporterVehicleDriverCardModalComponent, { centered: true, size: "lg", backdrop: 'static', keyboard: true });
    // this.modalRef.componentInstance.params = obj;
    // this.modalRef.componentInstance.navigateBackId = this.SelectedId;
    // this.modalRef.componentInstance.FTLType = this.ScreenName;

    this.modalRef.result
      .then(() => {
        this.isModalOpen = false;
      })
      .catch(() => {
        this.isModalOpen = false;
      });


  }

  getChangedValue(value, data) {
    if (value) {
      this.dataToSave[data.dataField] = value;
    }
  }

  closeModal() {
    this.modalRef.close();
  }

  GetTransporterList(value, isScrollDown = false) {
    this.Transporter.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.Transporter.dropdownList.length / 20) + 1;
    }
    this.orderService.TransporterSelect2(value, pageNo, this.TenantId).then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.Transporter.dropdownList.length) {
        dropdownList = dropdownList.concat(this.Transporter.dropdownList);
        this.Transporter = { ...this.Transporter, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.Transporter = { ...this.Transporter, dropdownList: [...dropdownList] });
      this.Transporter.isSearch = false;
    }).catch(error => {
      this.Transporter.isSearch = false;
    })
  }

  GetVehicleNoList(value, isScrollDown = false) {
    this.VehicleNo.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.VehicleNo.dropdownList.length / 40) + 1;
    }
    this.orderService.GetBookingVehicleNoSelect2(value, pageNo, this.dataY.Transporter, this.data.VehicleType).then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.VehicleNo.dropdownList.length) {
        dropdownList = dropdownList.concat(this.VehicleNo.dropdownList);
        this.VehicleNo = { ...this.VehicleNo, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.VehicleNo = { ...this.VehicleNo, dropdownList: [...dropdownList] });
      this.VehicleNo.isSearch = false;
    }).catch(error => {
      this.VehicleNo.isSearch = false;
    })
  }

  GetDriverList(value, isScrollDown = false) {
    this.Driver.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.Driver.dropdownList.length / 40) + 1;
    }
    this.orderService.GetDriverSelect2(value, pageNo, this.dataY.Transporter).then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.Driver.dropdownList.length) {
        dropdownList = dropdownList.concat(this.Driver.dropdownList);
        this.Driver = { ...this.Driver, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.Driver = { ...this.Driver, dropdownList: [...dropdownList] });
      this.Driver.isSearch = false;
    }).catch(error => {
      this.Driver.isSearch = false;
    })
  }

  PODmodalPass(event) {
    if (event.item.Code == 6 || event.item.Code == '6') {
      this.ConsignmentDetailId = event.row.ConsignmentDetailId
      this.TodayDate = new Date();
      this.TodayDate = this.datepipe.transform(this.TodayDate, "dd-MMM-yyyy HH:mm")
      this.ConsignmentNo = event.row.ConsignmentNo;
      this.ConfirmDeliverydata = {};
      this.ConfirmDeliverydata.TransporterId = event.row.TransporterId;
      this.ConfirmDeliverydata.DriverCode = event.row.DriverCode;
      this.ConfirmDeliverydata.VehicleNo = event.row.VehicleNo;
      this.ConfirmDeliverydata.BookingId = event.row.BookingId;
      this.ConfirmDeliverydata.CreatedBy = this.userId;
      this.ConfirmDeliverydata.ConsignmentDetailId = event.row.ConsignmentDetailId;
      this.GetDeliveryStatusList();
      this.AttachmenentUpload = false;
      this.GetConfirmDeliveryProductDetails(event.row.ConsignmentDetailId);
      this.modalRef = this.modalService.open(this.PODUploadmodal, { centered: true, size: "lg" });
    } else if (event.item.Code == 111 || event.item.Code == '111') {
      this.containerPickupData.TransporterId = event.row.TransporterId;
      this.containerPickupData.DriverCode = event.row.DriverCode;
      this.containerPickupData.VehicleNo = event.row.VehicleNo;
      this.containerPickupData.BookingId = event.row.BookingId;
      this.containerPickupData.containerNo = event.row.containerNo;
      this.containerPickupData.sealNo = event.row.sealNo;
      this.containerPickupData.weight = event.row.containerweight;
      this.containerPickupData.gateInTime = event.row.gateInTime;
      this.containerPickupData.gateOutTime = event.row.gateOutTime;
      this.containerPickupData.CreatedBy = this.userId;
      this.modalRef = this.modalService.open(this.showContainerPickupModal, { centered: true, size: "lg", windowClass: 'modal-md-custom-container-css', backdrop: 'static' });
    } else if (event.item.Code == 8 || event.item.Code == '8') {
      let BookingId = event.row.BookingId;
      this.BookingIdForConsignmentProduct = event.row.BookingId;
      this.IndentIdForConsignmentProduct = event.row.IndentId;
      this.ConsignmentDetailIdForConsignmentProduct = event.row.ConsignmentDetailId;
      this.BookingId = event.row.BookingId;
      this.ConsignmentDetailId = event.row.ConsignmentDetailId;
      this.VehicleNoForPartB = event.row.VehicleNo;
      this.TransporterGstIn = event.row.TransporterGstIn;
      this.loadedData.eWayBillNo = event.row.EwayBillNo || null; // Added by priya - 22/04/2026 - cn(PRIYA-APR26-010)
      this.loadedData.eWayBillExpDate = event.row.EwayExpiryDate ? new Date(event.row.EwayExpiryDate) : null; // Added by priya - 22/04/2026 - cn(PRIYA-APR26-010)
      this.fetchTripProductDetails(BookingId);
      // this._appService.GetById("OrdersByVehicle", "getNewTripProductsList", BookingId).subscribe((res) => {
      //   this.consignmentProductList = res;

      //   let TotalAmount = 0;
      //   let TotalBoxPerPallet = 0;
      //   let TotalQuantity = 0;
      //   let TotalWeight = 0;
      //   let TotalCBM = 0;
      //   this.consignmentProductList.forEach(ele => {
      //     TotalAmount += ele.Amount || 0;
      //     TotalBoxPerPallet += ele.BoxPerPallet || 0;
      //     TotalQuantity += ele.Quantity || 0;
      //     TotalWeight += ele.Weight || 0;
      //     TotalCBM += ele.CBM || 0;
      //   });

      //   this.consignmentProductTotalAmount = TotalAmount;
      //   this.consignmentProductTotalBoxPerPallet = TotalBoxPerPallet;
      //   this.consignmentProductTotalQuantity = TotalQuantity;
      //   this.consignmentProductTotalWeight = TotalWeight;

      //   this.consignmentProductCutomer = res[0].Customer;
      //   this.Product.dropdownList = res.map((ele: any) => ({
      //     name: ele.ProductName,
      //     value: ele.Product
      //   }));
      //   this.Unit.dropdownList = res.map((ele: any) => ({
      //     name: ele.UnitName,
      //     value: ele.Unit
      //   }));

      //   const vehicleWeight = res[0].totalVehicleWeight;
      //   if (vehicleWeight > 0) {
      //     this.loadConfirmationVehicleWeight = ((TotalWeight / vehicleWeight) * 100).toFixed(2);
      //   } else {
      //     this.loadConfirmationVehicleWeight = '0';
      //   }

      //   this.loadConfirmationVehicleType = res[0].vehicleType;
      //   this.loadConfirmationSubVehicleType = res[0].subVehicleType;
      //   // this.loadConfirmationVehicleWeight = res[0].totalVehicleWeight;
      //   this.loadConfirmationVehicleCBM = res[0].totalVehicleCBM;
      // },
      //   (err) => {
      //     this.toastr.error("Error while fetching product data", 'Product');
      //   }
      // );
      // this.isLoadConfirmationModalOpen = true;
      // this.modalRef = this.modalService.open(this.loadConfirmationModal, { centered: true, size: "lg" });
    } else if (event.item.Code == 100 || event.item.Code == '100') {
      this.BookingId = event.row.BookingId;
      this.modalRefForHistory = this.modalService.open(this.ChangeHistory, { centered: true, size: "lg" });
    } else if (event.item.Code == 101 || event.item.Code == '101') {
      this.dataY = {};
      this.dataY.BookingId = event.row.BookingId;
      this.dataY.Transporter = event.row.TransporterId.toLowerCase();
      this.dataY.VehicleNo = event.row.VehicleNo;
      this.dataY.Driver = event.row.DriverId;
      this.dataY.driverName = event.row.DriverCode;
      this.dataY.DriverLicense = event.row.LicenseNo;
      this.dataY.RCBookNo = event.row.RCBookNo;
      this.dataY.ChassisNo = event.row.ChassisNo;
      this.dataY.EngineNo = event.row.EngineNo;
      this.dataY.DriverMobileNo = event.row.DriverMobileNo;
      this.dataY.TransporterType = event.row.TransporterType;
      this.dataY.Reason = event.row.ChangeReason;
      this.GetTransporterList(event.row.Transporter, false);
      this.GetVehicleNoList(event.row.VehicleNo, false);
      this.GetReasonList(event.row.ChangeReasonName, false);
      // this.GetDriverList(event.row.DriverCode, false);
      this.Driver.dropdownList = [];
      let obj: any = {};
      obj.name = event.row.DriverCode;
      obj.value = event.row.DriverId;
      this.Driver.dropdownList.push(obj);

      setTimeout(() => {
        this.modalRef = this.modalService.open(this.ChangeTransDrivVehiclcontentY, { centered: true, size: "lg" });
      }, 1000);
    } else if (event.item.Code == 102 || event.item.Code == '102') {
      this.BookingId = event.row.BookingId;
      this.modalRef = this.modalService.open(this.tripsMilestonemodal, { centered: true, size: "lg" });
    } else if (event.item.Code == 103 || event.item.Code == '103') {
      window.open(`/Newtracking?id=` + event.row.ConsignmentDetailId + '&detailid=' + event.row.BookingId + '&type=NewTracking', '_blank');
    }
  }

  onTripActionClick(event) {

    //added by yash 23/04/2026
    console.log('TruckLoadView - onTripActionClick received:', event);
    
    let Item: string;
    let rowData: any = event && event.row ? event.row : null;
    
    // Try to extract from the correct nested level
    if (event && event.event && event.event.event && event.event.event.target && event.event.event.target.innerText) {
        Item = event.event.event.target.innerText;
        //console.log('Pattern 1 matched (3 levels deep):', Item);
    } 
    else if (event && event.event && event.event.target && event.event.target.innerText) {
        Item = event.event.target.innerText;
        //console.log('Pattern 2 matched (2 levels deep):', Item);
    }
    else if (event && event.target && event.target.innerText) {
        Item = event.target.innerText;
        //console.log('Pattern 3 matched (1 level deep):', Item);
    }
    else if (typeof event === 'string') {
        Item = event;
        //console.log('Pattern 4 matched (string):', Item);
    }
    else {
        Item = '';
        //console.log('No matching pattern');
    }
    
    //console.log('Final Item value:', Item);
    //console.log('Row data:', rowData);
    // end by yash 23/04/2026

    //let Item = event.event.target.innerText ? event.event.target.innerText : event.event; //comment by yash
    console.log('Clicked:', Item, event.row);
    if ( Item === 'Mark As Delivered') {
      this.ConsignmentDetailId = event.row.ConsignmentDetailId
      this.TodayDate = new Date();
      this.TodayDate = this.datepipe.transform(this.TodayDate, "dd-MMM-yyyy HH:mm")
      this.ConsignmentNo = event.row.ConsignmentNo;
      this.ConfirmDeliverydata = {};
      this.ConfirmDeliverydata.TransporterId = event.row.TransporterId;
      this.ConfirmDeliverydata.DriverCode = event.row.DriverCode;
      this.ConfirmDeliverydata.VehicleNo = event.row.VehicleNo;
      this.ConfirmDeliverydata.BookingId = event.row.BookingId;
      this.ConfirmDeliverydata.CreatedBy = this.userId;
      this.ConfirmDeliverydata.ConsignmentDetailId = event.row.ConsignmentDetailId;
      this.GetDeliveryStatusList();
      this.AttachmenentUpload = false;
      this.GetConfirmDeliveryProductDetails(event.row.ConsignmentDetailId);
      this.modalRef = this.modalService.open(this.PODUploadmodal, { centered: true, size: "lg" });
    } else if (Item === 'Mark As Container Picked') {
      this.containerPickupData.TransporterId = event.row.TransporterId;
      this.containerPickupData.DriverCode = event.row.DriverCode;
      this.containerPickupData.VehicleNo = event.row.VehicleNo;
      this.containerPickupData.BookingId = event.row.BookingId;
      this.containerPickupData.containerNo = event.row.containerNo;
      this.containerPickupData.sealNo = event.row.sealNo;
      this.containerPickupData.weight = event.row.containerweight;
      this.containerPickupData.gateInTime = event.row.gateInTime;
      this.containerPickupData.gateOutTime = event.row.gateOutTime;
      this.containerPickupData.CreatedBy = this.userId;
      this.modalRef = this.modalService.open(this.showContainerPickupModal, { centered: true, size: "lg", windowClass: 'modal-md-custom-container-css', backdrop: 'static' });
    } else if (Item === 'Mark As Loaded' || Item === 'Mark As De-Stuffed' || Item === 'Mark As Stuffed') {
      console.log('data action', event.row)
      let BookingId = event.row.BookingId;
      this.BookingIdForConsignmentProduct = event.row.BookingId;
      this.IndentIdForConsignmentProduct = event.row.IndentId;
      this.ConsignmentDetailIdForConsignmentProduct = event.row.ConsignmentDetailId;
      this.BookingId = event.row.BookingId;
      this.ConsignmentDetailId = event.row.ConsignmentDetailId;
      this.TransporterGstIn = event.row.TransporterGstIn;
      this.loadedData.eWayBillNo = event.row.EwayBillNo || null; // Added by priya - 22/04/2026 - cn(PRIYA-APR26-010)
      this.loadedData.eWayBillExpDate = event.row.EwayExpiryDate ? new Date(event.row.EwayExpiryDate) : null; // Added by priya - 22/04/2026 - cn(PRIYA-APR26-010)
      this.fetchTripProductDetails(BookingId);
      // this._appService.GetById("OrdersByVehicle", "getNewTripProductsList", BookingId).subscribe((res) => {
      //   this.consignmentProductList = res;

      //   let TotalAmount = 0;
      //   let TotalBoxPerPallet = 0;
      //   let TotalQuantity = 0;
      //   let TotalWeight = 0;
      //   let TotalCBM = 0;
      //   this.consignmentProductList.forEach(ele => {
      //     TotalAmount += ele.Amount || 0;
      //     TotalBoxPerPallet += ele.BoxPerPallet || 0;
      //     TotalQuantity += ele.Quantity || 0;
      //     TotalWeight += ele.Weight || 0;
      //     TotalCBM += ele.CBM || 0;
      //   });

      //   this.consignmentProductTotalAmount = TotalAmount;
      //   this.consignmentProductTotalBoxPerPallet = TotalBoxPerPallet;
      //   this.consignmentProductTotalQuantity = TotalQuantity;
      //   this.consignmentProductTotalWeight = TotalWeight;

      //   this.consignmentProductCutomer = res[0].Customer;
      //   this.Product.dropdownList = res.map((ele: any) => ({
      //     name: ele.ProductName,
      //     value: ele.Product
      //   }));
      //   this.Unit.dropdownList = res.map((ele: any) => ({
      //     name: ele.UnitName,
      //     value: ele.Unit
      //   }));

      //   const vehicleWeight = res[0].totalVehicleWeight;
      //   if (vehicleWeight > 0) {
      //     this.loadConfirmationVehicleWeight = ((TotalWeight / vehicleWeight) * 100).toFixed(2);
      //   } else {
      //     this.loadConfirmationVehicleWeight = '0';
      //   }

      //   this.loadConfirmationVehicleType = res[0].vehicleType;
      //   this.loadConfirmationSubVehicleType = res[0].subVehicleType;
      //   // this.loadConfirmationVehicleWeight = res[0].totalVehicleWeight;
      //   this.loadConfirmationVehicleCBM = res[0].totalVehicleCBM;
      // },
      //   (err) => {
      //     this.toastr.error("Error while fetching product data", 'Product');
      //   }
      // );
      // this.isLoadConfirmationModalOpen = true;
      // this.modalRef = this.modalService.open(this.loadConfirmationModal, { centered: true, size: "lg" });
    } else if (Item === 'Change History') {
      // this.BookingId = event.row.BookingId;
      // this.modalRefForHistory = this.modalService.open(this.ChangeHistory, { centered: true, size: "lg" });
      const modalRef = this.modalService.open(
      ChangeTranporterDriverHistoryComponent,
      {
        size: 'lg',
        centered: true,
        backdrop: 'static'
      }
    );

    modalRef.componentInstance.BookingId = event.row.BookingId;
    modalRef.componentInstance.HistoryType = 'All';
    } else if (Item === 'Change Transporter, Driver & Vehicle') {
      this.dataY = {};
      this.dataY.BookingId = event.row.BookingId;
      this.dataY.Transporter = event.row.TransporterId.toLowerCase();
      this.dataY.VehicleNo = event.row.VehicleNo;
      this.dataY.Driver = event.row.DriverId;
      this.dataY.driverName = event.row.DriverCode;
      this.dataY.DriverLicense = event.row.LicenseNo;
      this.dataY.RCBookNo = event.row.RCBookNo;
      this.dataY.ChassisNo = event.row.ChassisNo;
      this.dataY.EngineNo = event.row.EngineNo;
      this.dataY.DriverMobileNo = event.row.DriverMobileNo;
      this.dataY.TransporterType = event.row.TransporterType;
      this.dataY.Reason = event.row.ChangeReason;
      // Added by priya - 24/01/2026 - cn(PRIYA-JAN26-013)
      this.BookingId = this.dataY.BookingId;
      this.ConsignmentDetailId = event.row.ConsignmentDetailId
      // Added by priya - 30/01/2026 - cn(PRIYA-JAN26-015)
      this.TransporterIdForEway = event.row.TransporterId.toLowerCase();
      this.VehicleIdForEway = event.row.VehicleNo;
      if (this.EwayBillFiling) {
        if (this.VehicleIdForEway === this.dataY.VehicleNo && this.TransporterIdForEway === this.dataY.Transporter) {
          this.IsChangedTransDriVeh = false;
        } else {
          this.IsChangedTransDriVeh = true;
        }
      }
      // End by priya
      // Check for display validate eway bill btn
      // this.IsChangedTransDriVeh = event.row.ChangeReason;
      // End by priya
      this.GetTransporterList(event.row.Transporter, false);
      this.GetVehicleNoList(event.row.VehicleNo, false);
      this.GetReasonList(event.row.ChangeReasonName, false);
      // Added by priya - 24/01/2026 - Getting eway data in change transporter, driver & vehicle modal - cn(PRIYA-JAN26-013) -
      this.GetEwayLrData(this.BookingId, this.ConsignmentDetailId)
      // this.GetDriverList(event.row.DriverCode, false);
      this.Driver.dropdownList = [];
      let obj: any = {};
      obj.name = event.row.DriverCode;
      obj.value = event.row.DriverId;
      this.Driver.dropdownList.push(obj);

      setTimeout(() => {
        this.modalRef = this.modalService.open(this.ChangeTransDrivVehiclcontentY, { centered: true, size: "lg" });
      }, 1000);
    } else if (Item === 'Update Tracking Status') {
      this.BookingId = event.row.BookingId;
      this.modalRef = this.modalService.open(this.tripsMilestonemodal, { centered: true, size: "lg" });
    } else if (Item === 'Track') {
      // window.open(`/Newtracking?id=` + event.row.ConsignmentDetailId + '&detailid=' + event.row.BookingId + '&type=NewTracking', '_blank');
      const url = `/Newtracking?id=${event.row.ConsignmentDetailId}&detailid=${event.row.BookingId}&type=NewTracking`;
      const link: any = document.getElementById('hiddenTrackLink');
      link.href = url;
      link.click();
    } 
    //added by BURHAN - 6-May-2026
    else if (Item.trim() === 'Attachments') {
      this.openTripAttachment(event.row.ConsignmentDetailId);
    }
    //end by BURHAN

    // added by yash 23/04/2026
    else if (Item === 'Notes' || (event && event.event && event.event.actionName === 'Notes')){
      //console.log('notes detected! opening pnael');
      this.notesTransactionType = 'Trips';
      this.notesTransactionId = rowData.Id;
      console.log('Notes Type:', this.notesTransactionType);
      console.log('Notes Id:', this.notesTransactionId);
      this.isNotesPanelOpen = true;
      //console.log('notesTransactionType:', this.notesTransactionType);
      //console.log('notesTransactionId:', this.notesTransactionId);
      //console.log('isNotesOpen set to:', this.isNotesOpen);
    }
    // end by yash 23/04/2026
  }

  changeActiveStatus(status) {
    this.PODRecevied = status;
  }

  switchTab(event) {
    if (event != null) {
      this.tabTitle = event.originalEvent.target.innerText;
      // if(this.tabTitle === 'Details'){
      //     this.activeTabContext = 'DETAILS'
      // }else{
      //   this.activeTabContext = 'TRIPS'
      // }
      // this.activeTabContext = event.index === 0 ? 'DETAILS' : 'TRIPS';
    }
    if (this.tabTitle == 'Cost Sheet') {
      this.FtlCostSheetComponentChild.CompanyId = this.CompanyId;
      this.FtlCostSheetComponentChild.OrderId = this.SelectedId;
      this.FtlCostSheetComponentChild.TripId = null;

      this.FtlCostSheetComponentChild.GetCostData();
    }
    if (this.tabTitle == 'Activity') {
      this.QuotationlogChild.GetQuotationLogList(this.SelectedId);
    }
    if(this.tabTitle == 'Invoice'){
      this.GetShipmentInvoiceDataById();
    }
    this.GetPrintByCategory();
  }

  close() {
    this.isAttachmentShowForPOD = false;
  }

  getChangedValueForConfirm(value, data, index) {
    const newValue = value && typeof value === 'object' && 'value' in value ? value.value : value;
    if (newValue) {
      if (data.dataField == 'Damage' || data.dataField == 'Shortage' || data.dataField == 'SealShort') {
        if (newValue && !isNaN(newValue)) {
          this.confirmDeliveryProductDetail[index][data.dataField] = Number(newValue);
        }
      } else {
        this.confirmDeliveryProductDetail[index][data.dataField] = newValue;
      }
      // this.ConfirmDeliverydata[data.dataField] = newValue;
    } else {
      this.confirmDeliveryProductDetail[index][data.dataField] = null;
    }
  }

  GetDeliveryStatusList() {
    this._appService
      .GetById("Common", "GetLookByCategoryName", "DelvieryStatus")
      .subscribe(
        (response) => {
          response.map((ele) => {
            ele.value = ele.Id;
            ele.name = ele.Label;
          });
          this.DeliveryStatus.dropdownList = response || [];
          // this.DeliveryStatusList = response;
        },
        (err) => {
          this.toastr.error(
            "Error occurred while fetching Status data !",
            "error"
          );
        }
      );
  }

  GetConfirmDeliveryProductDetails(ConsignmentDetailId) {
    this._appService.GetById("OrdersByVehicle", "GetConfirmDeliveryProductDetails", ConsignmentDetailId).subscribe(
      (response) => {
        this.confirmDeliveryProductDetail = response;
        this.confirmDeliveryProductDetail.forEach(ele => {
          ele.DeliveryStatus = ele.DeliveryStatus || null; // Changed by priya - 01/04/2026 - cn(PRIYA-MAR26-015)
          ele.Damage = ele.Damage || null; // Changed by priya - 01/04/2026 - cn(PRIYA-MAR26-015)
          ele.Shortage = ele.Shortage || null; // Changed by priya - 01/04/2026 - cn(PRIYA-MAR26-015)
          ele.SealShort = ele.SealShort || null; // Changed by priya - 01/04/2026 - cn(PRIYA-MAR26-015)
          ele.Remark = ele.Remark || null; // Changed by priya - 01/04/2026 - cn(PRIYA-MAR26-015)
        });
      }
      , (err) => {
        this.toastr.error("Error while fetching product data", err);
      }
    );
  }

  attachmentCheck(event) {
    if (event == 'true' || event == true) {
      this.AttachmenentUpload = true;
    } else {
      this.AttachmenentUpload = false;
    }
  }

  saveConfirmedDelivery() {
    if (this.PODRecevied == true) {
      if (this.AttachmenentUpload == false) {
        this.toastr.warning("Please Attach POD Copy", 'POD');
        return;
      }
    }
    this.ConfirmDeliverydata.NewConfirmedDeliveryDetail_Table = [];
    this.ConfirmDeliverydata.NewConfirmedDeliveryDetail_Table = this.confirmDeliveryProductDetail;

    let Damage = 0;
    let Shortage = 0;
    let SealShort = 0;

    this.confirmDeliveryProductDetail.forEach(ele => {
      Damage += parseInt(ele.Damage) || 0;
      Shortage += parseInt(ele.Shortage) || 0;
      SealShort += parseInt(ele.SealShort) || 0;
    });

    this.ConfirmDeliverydata.NewConfirmedDeliveryDetail_Table.forEach(ele => {
      ele.PODRecevied = this.PODRecevied;
      ele.ConsignmentDetailId = this.ConfirmDeliverydata.ConsignmentDetailId;
    });

    this.ConfirmDeliverydata.Damage = Damage;
    this.ConfirmDeliverydata.Shortage = Shortage;
    this.ConfirmDeliverydata.SealShort = SealShort;

    this._appService.Post("OrdersByVehicle", "saveNewConfirmDeliveryData", this.ConfirmDeliverydata).subscribe((response) => {
      if (response) {
        this.toastr.success("Confirmed Delivery saved successfully");
        this.modalRef.close();
        if (this.ScreenName === 'NewTrips') {
          this.GetTripListById(this.SelectedId);
        } else {
          this.GetOrderVehicleById(this.SelectedId);
        }
      }
    },
      (err) => {
        this.toastr.error("Error while saving confirmed delivery", err);
      }

    );
  }

  // showAllPackagesModal(event) {
  //   if (event.show) {
  //     let BookingId = event.data.BookingId;
  //     this._appService.GetById("OrdersByVehicle", "getNewTripProductsList", BookingId).subscribe((res) => {
  //       this.tripsProductList.data = res;
  //       let TotalAmount = 0;
  //       let TotalBoxPerPallet = 0;
  //       let TotalQuantity = 0;
  //       let TotalWeight = 0;
  //       let TotalCBM = 0;
  //       this.tripsProductList.data.forEach(ele => {
  //         TotalAmount += ele.Amount || 0;
  //         TotalBoxPerPallet += ele.BoxPerPallet || 0;
  //         TotalQuantity += ele.Quantity || 0;
  //         TotalWeight += ele.Weight || 0;
  //         TotalCBM += ele.CBM || 0;
  //       });
  //       this.tripsProductList.footerData[0].Amount = TotalAmount;
  //       this.tripsProductList.footerData[0].BoxPerPallet = TotalBoxPerPallet;
  //       this.tripsProductList.footerData[0].Quantity = TotalQuantity;
  //       this.tripsProductList.footerData[0].Weight = TotalWeight;
  //       this.tripsProductList.footerData[0].CBM = TotalCBM;
  //     },
  //       (err) => {
  //         this.toastr.error("Error while fetching product data", 'Product');
  //       }
  //     );
  //     this.modalRef = this.modalService.open(this.showPackagesModal, { centered: true, size: "lg" });
  //   }
  // }

  showAllPackagesModal(event) {
    if (event.show) {
      const BookingId = event.data.BookingId;
      const isLTL = this.ScreenName === 'LTL';
      this.tripsProductList = {
        columnDetails: isLTL
          ? [
            { columnName: "Order No", dataFieldName: 'OrderNo', },
            { columnName: "Product", dataFieldName: 'ProductName' },
            { columnName: "Box/Pallet", dataFieldName: 'BoxPerPallet', alignType: 'right' },
            { columnName: "Qty", dataFieldName: 'Quantity', alignType: 'right' },
            { columnName: "Units", dataFieldName: 'UnitName' },
            { columnName: "Weight (Kgs)", dataFieldName: 'Weight', alignType: 'right' },
            { columnName: "Amount", dataFieldName: 'Amount', alignType: 'right' },
            { columnName: "Length", dataFieldName: 'Length', alignType: 'right' },
            { columnName: "Width", dataFieldName: 'Width', alignType: 'right' },
            { columnName: "Height", dataFieldName: 'Height', alignType: 'right' },
            { columnName: "CBM", dataFieldName: 'ProductCBM' },
          ]
          : [
            { columnName: "Order No", dataFieldName: 'OrderNo', },
            { columnName: "Product", dataFieldName: 'ProductName' },
            { columnName: "Box/Pallet", dataFieldName: 'BoxPerPallet', alignType: 'right' },
            { columnName: "Qty", dataFieldName: 'Quantity', alignType: 'right' },
            { columnName: "Units", dataFieldName: 'UnitName' },
            { columnName: "Weight (Kgs)", dataFieldName: 'Weight', alignType: 'right' },
            { columnName: "CBM", dataFieldName: 'CBM' },
            { columnName: "Amount", dataFieldName: 'Amount', alignType: 'right' },
          ],
        data: [],
        footerData: [
          {
            OrderNo: 'Total',
            ProductName: '',
            BoxPerPallet: 0,
            Quantity: 0,
            UnitName: '',
            Weight: 0,
            CBM: 0,
            Amount: 0,
            ...(isLTL && { Length: 0, Width: 0, Height: 0, ProductCBM: 0 })
          }
        ],
        isColumnNameShow: true,
        isShowFooterData: true
      };

      this._appService.GetById("OrdersByVehicle", "getNewTripProductsList", BookingId).subscribe(
        (res) => {
          this.tripsProductList.data = res;
          this.IsReachDestination = res[0].IsReachDestination;

          let TotalAmount = 0;
          let TotalBoxPerPallet = 0;
          let TotalQuantity = 0;
          let TotalWeight = 0;
          let TotalCBM = 0;
          let TotalLength = 0;
          let TotalWidth = 0;
          let TotalHeight = 0;
          let TotalProductCBM = 0;

          res.forEach(ele => {
            TotalAmount += ele.Amount || 0;
            TotalBoxPerPallet += ele.BoxPerPallet || 0;
            TotalQuantity += ele.Quantity || 0;
            TotalWeight += ele.Weight || 0;
            TotalCBM += ele.CBM || 0;

            if (isLTL) {
              TotalLength += ele.Length || 0;
              TotalWidth += ele.Width || 0;
              TotalHeight += ele.Height || 0;
              const cbm = (
                (ele.Length || 0) *
                (ele.Width || 0) *
                (ele.Height || 0) *
                (ele.BoxPerPallet || 0)
              ) / 1000000;
              ele.ProductCBM = parseFloat(cbm.toFixed(2));
              TotalProductCBM += ele.ProductCBM;
            }
          });

          const footer = this.tripsProductList.footerData[0];
          footer.Amount = TotalAmount;
          footer.BoxPerPallet = TotalBoxPerPallet;
          footer.Quantity = TotalQuantity;
          footer.Weight = TotalWeight;
          footer.CBM = parseFloat(TotalCBM.toFixed(2));;

          if (isLTL) {
            footer.Length = TotalLength;
            footer.Width = TotalWidth;
            footer.Height = TotalHeight;
            footer.ProductCBM = TotalProductCBM;
          }
        },
        (err) => {
          this.toastr.error("Error while fetching product data", 'Product');
        }
      );

      this.modalRef = this.modalService.open(this.showPackagesModal, {
        centered: true,
        size: "lg"
      });
    }
  }


  getChangedValueForContainer(value, data) {
    const newValue = value && typeof value === 'object' && 'value' in value ? value.value : value;
    if (newValue) {
      if (data.dataField == 'weight') {
        if (newValue && !isNaN(newValue)) {
          this.containerPickupData[data.dataField] = Number(newValue);
        }
      } else {
        this.containerPickupData[data.dataField] = newValue;
      }
    } else {
      this.containerPickupData[data.dataField] = null;
    }
  }

  getChangedValueForLoaded(value, data) {
    const newValue = value && typeof value === 'object' && 'value' in value ? value.value : value;
    // Added by priya - 22/01/2026 - Getting eway ulip data - cn(PRIYA-JAN26-013)
    if (data.dataField == 'eWayBillNo') {
      // this.data[data.dataField] = value;
      // this.ValidateEwayUlip(value)
      // this.ShowEwayUlipDetails(value)
      // Added by priya - 28/01/2026 - displayed error if ewaybill no is more than 12 digit - cn(PRIYA-JAN26-014)
      const val = String(value);
      if(val.length < 12){
        this.IsValidateEwayUlip = false;
      }
      this.loadedData[data.dataField] = value;
      this.data[data.dataField] = value;
      this.loadedData.eWayBillExpDate = null;
      this.ewayBillExpiryDays = null;
      const trimmed = val.slice(0, 12);
      if (trimmed.length === 12) {
        this.GetVerifiedEwayBillData(this.ConsignmentDetailId, trimmed);
      }
      return;
      // this.GetVerifiedEwayBillData(this.ConsignmentDetailId, value);
    }
    if (newValue) {
      this.loadedData[data.dataField] = newValue;
    }
  }

  saveContainerPickup() {
    this.isFormSubmit = true;
    if (this.commonService.isStringEmptyOrNull(this.containerPickupData.containerNo)) {
      this.toastr.error("Container No is required", 'ContainerNo');
      return;
    }

    if (this.commonService.isStringEmptyOrNull(this.containerPickupData.sealNo)) {
      this.toastr.error("Seal No is required", 'SealNo');
      return;
    }

    // Added by priya - 28/07/2026 - cn(PRIYA-JUL26-016)
    const containerNo = this.containerPickupData.containerNo.trim().toUpperCase();
    // ISO 6346 format: 4 letters (last must be U/J/Z) + 7 digits - (U = Freight container, J = Detachable equipment, Z = Trailer or chassis)
    const containerRegex = /^[A-Z]{3}[UJZ]{1}[0-9]{7}$/;
    if (!containerRegex.test(containerNo)) {
      this.toastr.warning("Please enter a valid Container No (e.g. MSCU1234567).", "Container No");
      return;
    }
    // End by priya

    this._appService.Post("OrdersByVehicle", "saveNewECPickupData", this.containerPickupData).subscribe(() => {
      this.toastr.success("Container Details Saved Successfully");
      this.modalRef.close();
      if (this.ScreenName === 'NewTrips') {
        this.GetTripListById(this.SelectedId);
      } else {
        this.GetOrderVehicleById(this.SelectedId);
      }
    }, err => {
      this.toastr.error(err._body.replace(/"/g, ""), "error");
    });
  }

  getChangedConsignmentProduct(value, data, index) {
    const newValue = value && typeof value === 'object' && 'value' in value ? value.value : value;
    if (newValue) {
      if (data.dataField == 'BoxPerPallet' || data.dataField == 'Quantity' || data.dataField == 'Weight' || data.dataField == 'Amount') {
        if (newValue && !isNaN(newValue)) {
          this.consignmentProductList[index][data.dataField] = Number(newValue);
        }
      } else if (data.dataField == 'Product') {
        this.consignmentProductList[index][data.dataField] = newValue;
        this.consignmentProductList[index].ProductId = newValue;
        this.consignmentProductList[index].ProductName = value.name;
      }
      else {
        this.consignmentProductList[index][data.dataField] = newValue;
      }


      if (index > 0) {
        this.consignmentProductList[index].ConsignmentNoteDetailId = this.consignmentProductList[index - 1].ConsignmentNoteDetailId || this.ConsignmentDetailIdForConsignmentProduct;
        this.consignmentProductList[index].OrderNo = this.consignmentProductList[index - 1].OrderNo;
        this.consignmentProductList[index].OrderByVehicleID = this.consignmentProductList[index - 1].OrderByVehicleID || this.IndentIdForConsignmentProduct;
      }
    } else {
      this.consignmentProductList[index][data.dataField] = null;
      this.consignmentProductList[index].ProductId = null;
      this.consignmentProductList[index].ProductName = null;
    }
  }

  removeProduct(id, Index) {
    if (id === null || id === undefined) {
      if (this.consignmentProductList.length > 1) {
        this.consignmentProductList.splice(Index, 1);
      }
    } else {
      const dialogRef = this.modalService.open(ConfirmationPopupComponent, { centered: true });
      dialogRef.componentInstance.details = {
        message: 'Are you sure you want to delete this?',
        title: 'Confirmation',
      }
      dialogRef.componentInstance.close.subscribe((res: any) => {
        if (res) {
          this._appService.GetByIdparam("Booking", "deleteConsignmentProductDetails", id, this.userId).subscribe(
            (response) => {
              if (response[0].Message === 'OK') {
                this.toastr.success("Data Deleted Succcessfully", "Success");
                this.fetchTripProductDetails(this.BookingIdForConsignmentProduct);
              }
            },
            (err) => {
              this.toastr.error(err._body.replace(/"/g, ""), "Error");
            }
          );
        }
        dialogRef.close();
      });
    }
  }

  AddProduct() {
    const lastRow = this.consignmentProductList.length > 0
      ? this.consignmentProductList[this.consignmentProductList.length - 1]
      : { OrderNo: '', ReferenceNo: '' };

    this.consignmentProductList.push({
      OrderNo: lastRow.OrderNo,
      ReferenceNo: lastRow.ReferenceNo,
      Product: null,
      BoxPerPallet: null,
      Quantity: null,
      Unit: null,
      Weight: null,
      Amount: null
    });
  }

  closeLoadConfirmationModal() {
    this.modalClosing = true;
    setTimeout(() => {
      this.isLoadConfirmationModalOpen = false;
      this.modalClosing = false;
      // this.IsVerifiedEway = false;
      // Added by priya - 22/01/2026 - resetting value when load modal close - cn(PRIYA-JAN26-013)
      this.IsValidateEwayUlip = false;
      this.loadedData.eWayBillExpDate = null;
      this.ewayBillExpiryDays = null;
    }, 300);
    // this.isLoadConfirmationModalOpen = false;
  }

  getDropdownListV2Product(value, isScrollDown = false) {
    this.Product.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.Product.dropdownList.length / 20) + 1;
    }
    this.orderService.getProductSelect2(value, pageNo, this.consignmentProductCutomer).then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.Product.dropdownList.length) {
        dropdownList = dropdownList.concat(this.Product.dropdownList);
        this.Product = { ...this.Product, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.Product = { ...this.Product, dropdownList: [...dropdownList] });
      this.Product.isSearch = false;
    }).catch(error => {
      this.Product.isSearch = false;
    })
  }

  getDropdownListV2Unit(value, isScrollDown = false) {
    this.Unit.isSearch = true;
    this.orderService.GetUnitList().then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.Unit.dropdownList.length) {
        dropdownList = dropdownList.concat(this.Unit.dropdownList);
        this.Unit = { ...this.Unit, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.Unit = { ...this.Unit, dropdownList: [...dropdownList] });
      this.Unit.isSearch = false;
    }).catch(error => {
      this.Unit.isSearch = false;
    })
  }

  searchStatusOnField(data, Status) {
    data.isSearch = Status;
  }

  findObjectOfTheFieldV2(data, dropdownList) {
    data.dropdownList = dropdownList;
    data.isSearch = false;
    if (data.dataField) {
      data.isReadOnly = false
    }
  }

  saveConsignmentProduct() {
    if(this.EwayBillFiling){
      if (this.IsEwayBillNoExists == 'EwayExists') {
        this.toastr.warning('Eway Bill Already Exist')
        return;
      }
    }
    //added by BURHAN - 23-April-2026
    if (this.isAutoNumberingFlag == false) {
          var OrderNo = this.loadedData.OrderNo == undefined ? null : this.loadedData.OrderNo;
          this._appService
            .GetByTwoId("OrdersByVehicle", "CheckManaulLRExist", this.loadedData.LRNo, OrderNo)
            .subscribe(
              (response) => {
                console.log('Manual LR Check :', response);
                if (response == true) {
                  this.toastr.error(this.translate.instant("BYVEHICLE.ManualLRExist"));
                  Helpers.setLoading(false);
                  return;
                }
              },
              (err) => {
                this.toastr.error(err._body.replace(/"/g, ""), "error");
              }
            );
    }
    //end by BURHAN

    if (this.loadConfirmationVehicleWeight > 100) {
      const dialogRef = this.modalService.open(ConfirmationPopupComponent, { centered: true });
      dialogRef.componentInstance.details = {
        message: 'You are overloading the vehicle. Are you sure you want to save?"',
        title: 'Confirmation',
        action: 'Yes, Save it',
      }
      dialogRef.componentInstance.close.subscribe((res: any) => {
        if (res) {
          this.saveConsignmentProdData();
        }
        dialogRef.close();
      });
    } else {
      this.saveConsignmentProdData();
    }


  }

  saveConsignmentProdData() {
    let obj: any = {};
    obj.CreatedBy = this.userId;
    obj.InvoiceNo = this.loadedData.InvoiceNo;
    obj.InvoiceDate = this.loadedData.InvoiceDate;
    obj.eWayBillNo = this.loadedData.eWayBillNo;
    obj.eWayBillExpiryDate = this.loadedData.eWayBillExpDate;
    obj.IrnNo = this.loadedData.IrnNo; // Added by priya - 03/02/2026 - sending irn no for saving - cn(PRIYA-JAN26-016)
    obj.ConsignmentDetailId = this.ConsignmentDetailIdForConsignmentProduct; // Added by priya - 22/04/2026 - cn(PRIYA-APR26-010)
    obj.ManualLRNumber = this.loadedData.LRNo; //Added by BURHAN - 23-April-2026

    this.consignmentProductList.forEach((ele) => {
      ele.GrossWeight = ele.Weight;
      ele.ProductId = ele.Product,
        ele.Value = ele.Amount;
    });
    obj.NewConsignmentProductDet_Table = this.consignmentProductList;

    this._appService.Post("OrdersByVehicle", "saveNewConsignmentProductDataTrips", obj).subscribe(
      (response) => {
        if (response) {
          this.isLoadConfirmationModalOpen = false;
          this.toastr.success("Data saved successfully.", "Load Confirmation");
          this.loadedData = {};
          // this.UpdateGateInStage();
          this.saveLoadedMilestone();
        }
      },
      (err) => {
        console.error("Error while saving Load Confirmation", err);
      }
    );
  }

  getChangedValueY(value, data) {
    if (data.dataField == 'Transporter') {
      this.dataY[data.dataField] = value.value;
      this.dataY.TransporterType = value.TransporterType;
    } else if (data.dataField == 'VehicleNo') {
      // commented and added by priya - 23/05/2026 - cn(PRIYA-MAY26-006)
      // this.dataY[data.dataField] = value.value;
      const newValue = value && typeof value === 'object' && 'value' in value ? value.value : value;
      this.dataY[data.dataField] = newValue;
      // End by priya
    } else if (data.dataField == 'Driver') {
      // commented and added by priya - 23/05/2026 - cn(PRIYA-MAY26-006)
      // this.dataY[data.dataField] = value.value;
      // this.dataY.driverName = value.value;
      const newValue = value && typeof value === 'object' && 'value' in value ? value.value : value;
      this.dataY[data.dataField] = newValue;
      this.dataY.driverName = newValue;
      // End by priya
      const mobileNo = value.MobileNo;
      const parsedMobile = Number(mobileNo);
      // Check if it's a valid number before assigning
      this.dataY.DriverMobileNo = !isNaN(parsedMobile) ? parsedMobile : 0;
      // this.dataY.DriverMobileNo = value.MobileNo;
      this.dataY.DriverLicense = value.LicenseNo;
      this.dataY.RCBookNo = value.RCBookNo;
      this.dataY.ChassisNo = value.ChassisNo;
      this.dataY.EngineNo = value.EngineNo;
    } else if (data.dataField == 'Reason') {
      this.dataY[data.dataField] = value.value;
    } else {
      this.dataY[data.dataField] = value;
    }
    // Added by priya - 30/01/2026 - cn(PRIYA-JAN26-015)
    if(this.EwayBillFiling){
      if (this.VehicleIdForEway === this.dataY.VehicleNo && this.TransporterIdForEway === this.dataY.Transporter) {
        this.IsChangedTransDriVeh = false;
      } else {
        this.IsChangedTransDriVeh = true;
      }
    }
  }

  ValidateData() {
    var IsAllDataDone: any = true;
    if (!this.dataY.Transporter) {
      IsAllDataDone = false;
    }
    if (!this.dataY.VehicleNo) {
      IsAllDataDone = false;
    }
    if (!this.dataY.Driver) {
      IsAllDataDone = false;
    }
    if (!this.dataY.DriverMobileNo) {
      IsAllDataDone = false;
    }
    if (!this.dataY.Reason) {
      IsAllDataDone = false;
    }
    if (!IsAllDataDone) {
      var RequiredError = this.translate.instant("DriverDetailsById.RequiredError");
      this.toastr.error(RequiredError, "error");
    }
    return IsAllDataDone;
  }

  UpdateTranDriverVehicleNo() {
    this.isFormSubmitY = true;
    if (this.ValidateData()) {

      var changeAssignVehcle: any = {};
      changeAssignVehcle.bookingId = this.dataY.BookingId;;
      changeAssignVehcle.TransporterId = this.dataY.Transporter;
      changeAssignVehcle.vehicleNo = this.dataY.VehicleNo;
      changeAssignVehcle.rcBookNo = this.dataY.RCBookNo;
      changeAssignVehcle.chassisNo = this.dataY.ChassisNo;
      changeAssignVehcle.engineNo = this.dataY.EngineNo;
      changeAssignVehcle.transporterType = this.dataY.TransporterType;
      changeAssignVehcle.driverName = this.dataY.driverName;
      changeAssignVehcle.DriverMobileNo = this.dataY.DriverMobileNo;
      changeAssignVehcle.licenseNo = this.dataY.DriverLicense;
      if (this.ScreenName == 'FTL') {
        changeAssignVehcle.stageName = 'FTL';
      } else if (this.ScreenName == 'ContainerMovement') {
        changeAssignVehcle.stageName = 'ContainerMovement';
      } else {
        changeAssignVehcle.stageName = 'FTL';
      }

      changeAssignVehcle.UserId = this.userId;
      changeAssignVehcle.Reason = this.dataY.Reason;
      
      this._appService.Post("BookingOrigin", "changeTransDriverOfBooking", changeAssignVehcle).subscribe((response) => {
        this.toastr.success('Succssfully Saved!', 'Ok');
        // this.IsChangedTransDriVeh = this.dataY.Reason;
        this.GetOrderVehicleById(this.SelectedId);
        // this.modalRef.close();
      },
        (err) => {
          this.toastr.error(err._body.replace(/"/g, ""), "error");
        });
    }
  }

  GetReasonList(value, isScrollDown = false) {
    this.Reason.isSearch = true;
    let type = 'Change Transporter Driver and Vehicle'
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.Reason.dropdownList.length / 20) + 1;
    }
    this.orderService.ReasonSelect2(value, pageNo, type).then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.Reason.dropdownList.length) {
        dropdownList = dropdownList.concat(this.Reason.dropdownList);
        this.Reason = { ...this.Reason, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.Reason = { ...this.Reason, dropdownList: [...dropdownList] });
      this.Reason.isSearch = false;
    }).catch(error => {
      this.Reason.isSearch = false;
    })
  }

  getMileStoneList() {
    this._appService.GetByTwoParam("OrdersByVehicle", "getMileStoneList", this.BookingId, this.TransportService).subscribe(
      (response) => {
        this.mileStoneArray = response;

        this.stages = this.mileStoneArray.map((item: any, index: number) => {
          const actualDate = item.ActualDate ? new Date(item.ActualDate) : null;
          const time = item.ActualTime ? new Date(item.ActualDate) : null;

          return {
            id: index + 1,
            label: item.stageName || '',
            date: actualDate,
            time: time,
            completed: !!item.ActualDate  // true if ActualDate exists
          };
        });
      },
      (error) => {
        this.toastr.error(error._body.replace(/"/g, ""), "error");
      }
    );
  }

  private fetchTripProductDetails(BookingId): void {
    this._appService.GetById("OrdersByVehicle", "getNewTripProductsList", BookingId).subscribe((res) => {
      if (res && res.length > 0) {
        this.consignmentProductList = res;
        this.IsReachDestination = res[0].IsReachDestination;

        let TotalAmount = 0;
        let TotalBoxPerPallet = 0;
        let TotalQuantity = 0;
        let TotalWeight = 0;
        let TotalCBM = 0;
        this.consignmentProductList.forEach(ele => {
          TotalAmount += ele.Amount || 0;
          TotalBoxPerPallet += ele.BoxPerPallet || 0;
          TotalQuantity += ele.Quantity || 0;
          TotalWeight += ele.Weight || 0;
          TotalCBM += ele.CBM || 0;
        });

        if (res.length > 0) {
          // added by vithu 19-09-2025 - Siddarth
          this.loadedData.InvoiceNo = res[0].InvoiceNo;
          this.loadedData.InvoiceDate = res[0].InvoiceDate ? new Date(res[0].InvoiceDate) : null;
          // this.loadedData.eWayBillNo = res[0].eWayBillNo;
          // Added by priya - 03/02/2026 - Displayed irn no - cn(PRIYA-JAN26-016)
          this.loadedData.IrnNo = res[0].IrnNumber;
          if (this.loadedData.eWayBillNo !== null){
            this.GetVerifiedEwayBillData(this.ConsignmentDetailId, this.loadedData.eWayBillNo)
          }
          // End by priya
          this.loadedData.LRNo = res[0].LRNumber ? res[0].LRNumber : null;//added by BURHAN - 22-April-2026
          this.loadedData.eWayBillExpDate = res[0].eWayBillExpiryDate ? new Date(res[0].eWayBillExpiryDate) : null;
        }

        this.consignmentProductTotalAmount = TotalAmount;
        this.consignmentProductTotalBoxPerPallet = TotalBoxPerPallet;
        this.consignmentProductTotalQuantity = TotalQuantity;
        this.consignmentProductTotalWeight = TotalWeight;

        this.consignmentProductCutomer = res[0].Customer;
        this.Product.dropdownList = res.map((ele: any) => ({
          name: ele.ProductName,
          value: ele.Product
        }));
        this.Unit.dropdownList = res.map((ele: any) => ({
          name: ele.UnitName,
          value: ele.Unit
        }));

        const vehicleWeight = res[0].totalVehicleWeight;
        if (vehicleWeight > 0) {
          this.loadConfirmationVehicleWeight = ((TotalWeight / vehicleWeight) * 100).toFixed(2);
        } else {
          this.loadConfirmationVehicleWeight = '0';
        }

        const vehicleCBM = res[0].totalVehicleCBM;
        if (vehicleCBM > 0) {
          this.loadConfirmationVehicleCBM = ((TotalCBM / vehicleCBM) * 100).toFixed(2);
        } else {
          this.loadConfirmationVehicleCBM = '0';
        }

        this.loadConfirmationVehicleType = res[0].vehicleType;
        this.loadConfirmationSubVehicleType = res[0].subVehicleType;
        // this.loadConfirmationVehicleWeight = res[0].totalVehicleWeight;
        // this.loadConfirmationVehicleCBM = res[0].totalVehicleCBM;
        this.GetEwayLrData(BookingId, this.ConsignmentDetailId);
        setTimeout(() => {
          this.isLoadConfirmationModalOpen = true;
        }, 300);
        if(res[0].ConfirmLoadDate !== null || res[0].ConfirmLoadDate === ''){
          this.ConfirmLoadDate=res[0].ConfirmLoadDate;
        }else{
          this.ConfirmLoadDate=new Date();
        }
      } else {
        this.consignmentProductList = [];
        this.loadConfirmationVehicleWeight = '0';
        this.loadConfirmationVehicleCBM = '0';
        this.ConfirmLoadDate=new Date();
        this.GetEwayLrData(BookingId, this.ConsignmentDetailId);
        setTimeout(() => {
          this.isLoadConfirmationModalOpen = true;
        }, 300);
      }
    },
      (err) => {
        this.toastr.error("Error while fetching product data", 'Product');
      }
    );
  }



  GotoShipNow() {
    localStorage.setItem('RowData', JSON.stringify(this.data.Order));
    if (this.SelectedId) {
      if (this.ScreenName === 'FTL') {
        this.router.navigateByUrl(`/Ftl-ShipNow?id=` + this.SelectedId + `&type=FTL`);
      } else if (this.ScreenName === 'ContainerMovement') {
        this.router.navigateByUrl(`/Ftl-ShipNow?id=` + this.SelectedId + `&type=ContainerMovement`);
      }

    }
  }

  changeContainerActions() {
    this.PrintNameList = [];
    this._appService.GetByOneParam('Lookup', 'GetPrintByCategory', 'LRPrint').subscribe(
      (response) => {
        const visibleItems = response.filter(item => item.isVisible === true);
        visibleItems.forEach(element => {
          if (this.ScreenName === 'ContainerMovement') {
            const desiredOrder = [
              'Track',
              'Print Lorry Receipt',
              'Mark As Container Picked',
              'Mark As Loaded',
              'Mark As Delivered',
              'Update Tracking Status',
              'Change Transporter, Driver & Vehicle',
              'Change History',
              'Record Income',
              'Trip Expense'
            ];

            const service = this.SelectedTransportService.toLowerCase();
            let insertItem = service === 'import container' ? 'Mark As De-Stuffed' : 'Mark As Stuffed';

            const loadedIndex = desiredOrder.indexOf('Mark As Loaded');
            if (loadedIndex !== -1) {
              desiredOrder[loadedIndex] = insertItem;
            }

            const alreadyInVisible = visibleItems.some(item => item.PrintName === insertItem);
            if (!alreadyInVisible) {
              visibleItems.push({
                PrintName: insertItem,
                Code: '8',
                CategoryName: 'LRPrint',
                isVisible: true
              });
            }


            let ftlItems = visibleItems.filter(item => desiredOrder.includes(item.PrintName));

            ftlItems = ftlItems.sort((a, b) => {
              return desiredOrder.indexOf(a.PrintName) - desiredOrder.indexOf(b.PrintName);
            });

            this.PrintNameList = ftlItems;
          }
        });

      },
      (err) => {
        console.error('Error while changing Actions for container');
      }
    );
  }

  obv_deleteOrder() {
    let type ="";
    if(this.ScreenName == 'ContainerMovement'){
      type='FTL Container Movement';
    }else{
      type='FTL Point To Point';
    }
    this.checkEntityAndServiceAvailability(this.SelectedId, type).subscribe(
      (response) => {
      if (response && response.length > 0 && response[0].Availability === 'Available') {
        this.toastr.warning('Deletion not allowed: This item is currently referenced in one or more transactions.');
      } else {
        return new Promise((resolve) => {
          const dialogRef = this.modalService.open(ConfirmationPopupComponent, { centered: true });
          dialogRef.componentInstance.details = {
            message: 'Are you sure you want to delete this order?',
            title: 'Confirmation',
          }
          dialogRef.componentInstance.close.subscribe((res: any) => {
            if (res) {
              Helpers.setLoading(true);
              this._appService.Delete("OrdersByVehicle", "DeleteVehicleOrders", this.SelectedId).subscribe((response) => {
                Helpers.setLoading(false);
                this.toastr.success("Data deleted successfully", "success");
                this.GetOrderVehicleById(this.SelectedId);
              },
                (err) => {
                  this.toastr.error(err._body.replace(/"/g, ""), "error");
                  Helpers.setLoading(false);
                }
              );
            }
            dialogRef.close();
          });
        })
     }
    });
  }

  UpdateGateInStage() {
    this._appService.GetByTwoParam('Common', 'UpdateGateInStage', this.BookingIdForConsignmentProduct, this.userId).subscribe(
      (response) => {
        this.toastr.success('Loading Tracking Status Updated !');
        if (this.ScreenName === 'NewTrips') {
          this.GetTripListById(this.SelectedId);
        } else {
          this.GetOrderVehicleById(this.SelectedId);
        }
      },
      (error) => {
        this.toastr.error('Error while updating Loading Tracking Status');
      }
    );
  }

  setOpenedDropdown(index: number) {
    this.selectedDropdownIndex = index;
  }

  get ListDropdownType() {
    let type = this.ScreenName.toLowerCase();
    console.log('listdropdowntype:', type); // added by yash
    if (type === 'ftl') return 'FtlList';
    if (type === 'containermovement') return 'FtlContainerList';
    if (type === 'ltl') return 'LTLList';
    return 'FtlList';
  }

  checkEntityAndServiceAvailability(id, type): Observable<any> {
    return this._appService.GetByTwoParam('Network', 'checkDriverAndVehicleAvailability', id, type);
  }

  onCostSheetRefresh(){
      this.FtlCostSheetComponentChild.CompanyId = this.CompanyId;
      this.FtlCostSheetComponentChild.OrderId = this.SelectedId;
      this.FtlCostSheetComponentChild.TripId = null;

      this.FtlCostSheetComponentChild.GetCostData();     
  }

  closeHistoryModal() {
    this.modalRefForHistory.close();
  }

  PrintQuote() {
    this.PrintFormatsChild.OrderId = this.SelectedId;
    // this.PrintFormatsChild.InvoiceType = 'NewPrintQuote';
    this.PrintFormatsChild.UserId = this.userId;
    this.PrintFormatsChild.CompanyId = this.CompanyId;
    this.PrintFormatsChild.NewPrintQuote();
  }

  RefreshPage(event){
    if(event === 'true'){
      if (this.ScreenName === 'NewTrips') {
        this.GetTripListById(this.SelectedId);
      } else {
        this.GetOrderVehicleById(this.SelectedId);
      }
    }
  }

  
  getChangeComman(value, data) {
    const newValue = value && typeof value === 'object' && 'value' in value ? value.value : value;
    if (newValue) {
      if(data.dataField == 'LoadConfirmDateTime'){
        this.ConfirmLoadDate = newValue;
      }
    }else{
      this.ConfirmLoadDate = null;
    }
  }

  saveLoadedMilestone(){
    var obj:any={};
    obj.BookingId=this.BookingIdForConsignmentProduct;
    obj.CreatedBy=this.userId;
    obj.ActualDate=this.ConfirmLoadDate;
    this._appService.Post('Booking','saveLoadedMilestone',obj).subscribe(
      (response)=>{
        console.log('saveLoadedMilestone Executed Successfully');
        if (this.ScreenName === 'NewTrips') {
          this.GetTripListById(this.SelectedId);
        } else {
          this.GetOrderVehicleById(this.SelectedId);
        }
      },
      (error)=>{
        this.toastr.error('Error while updating milestone data','Error');
      }
    );
  }

  // Added and commented by priya - 22/01/2026 - getting system setting value for ulip functionality - cn(PRIYA-JAN26-013)
  LoadULIPVerification() {
    this._appService.GetById("Common", "GetSystemSettingByName", "ULIPVerification").subscribe((response) => {
      if (response == '1') {
        this.ULIPVerification = true;
      } else {
        this.ULIPVerification = false;
      }
    },
      (err) => {
        this.toastr.error("Error occurred while fetching Status data !", "error");
      });
  }

  // Added and commented by priya - 22/01/2026 - Validating eway bill ulip - cn(PRIYA-JAN26-013)
  ValidateEwayUlip() {
    var ewayBillNo = this.loadedData.eWayBillNo;
    this.loadedData.eWayBillExpDate = null;
    return this.Ulip.ValidateEwayBillUlip(ewayBillNo).then(res => {
      this.ewayData = res.ewayData;
      this.IsValidateEwayUlip = true;
      if (this.ewayData && Object.keys(this.ewayData).length > 0) {
        this.loadedData.eWayBillExpDate = this.ewayData.ewayBillvalidUpto;
        const ewayVehicle = (this.ewayData.vehicleNo || '').toString().trim().toUpperCase();
        const partBVehicle = (this.EwayConsignmentList[0].VehicleNumber || '').toString().trim().toUpperCase();
        if (ewayVehicle === partBVehicle) {
          this.IsVerifiedEway = true;
        } else {
          this.IsVerifiedEway = false;
        }
      } else {
        return Promise.resolve();
      }
    }).catch(err => {
      this.IsValidateEwayUlip = false;
      return Promise.resolve();
    });
  }

  // Added by priya - 22/01/2026 - Getting eway ulip data - cn(PRIYA-JAN26-013)
  ShowEwayUlipDetails(ewayBillNo) {
    this.loadedData.eWayBillExpDate = null;
    this.Ulip.GetEwayUlipData(ewayBillNo).then(res => {
      if (Array.isArray(res) && res.length > 0) {
        this.ewayData = res[0];
        this.loadedData.eWayBillExpDate = this.ewayData.ewayBillvalidUpto;
        this.IsValidateEwayUlip = true;
        if (this.EwayConsignmentList && this.EwayConsignmentList.length){
          this.EwayConsignmentList = this.EwayConsignmentList.map(item => {
            return {
              ...item,               // keep existing properties
              ewayCreatedDate: this.ewayData.ewayBillDate ? this.ewayData.ewayBillDate : item.ewayCreatedDate,
              eway_bill_number: this.ewayData.EwayBillNo ? this.ewayData.EwayBillNo : item.eway_bill_number // add new property
            };
          });
        }
        const ewayVehicle = (this.ewayData.vehicleNo || '').toString().trim().toUpperCase();
        const partBVehicle = (this.EwayConsignmentList[0].VehicleNumber || '').toString().trim().toUpperCase();
        if (ewayVehicle === partBVehicle) {
          this.IsVerifiedEway = true;
        } else {
          this.IsVerifiedEway = false;
        }
      } else {
        this.ewayData = null;
        this.IsValidateEwayUlip = false;
      }
    })
      .catch(err => {
        console.log(err)
      });
  }

  // Added by priya - 23/01/2026 - Getting eway lr data - cn(PRIYA-JAN26-013)
  GetEwayLrData(BookingId, ConsignmentDetailId){
    this.Eway.GetEwayLrData(BookingId, ConsignmentDetailId).then(data => {
      this.EwayConsignmentList = data;
      // Added by priya - 22/04/2026 - cn(PRIYA-APR26-010)
      if (this.EwayConsignmentList && this.EwayConsignmentList.length) {
        this.EwayConsignmentList = this.EwayConsignmentList.map(item => {
          return {
            ...item,               // keep existing properties
            TransporterGST: this.CompanyGSTIN, 
          };
        });
      }
      // End by priya
      // this.EwayConsignmentList = data;
      this.EwayBillNo = this.EwayConsignmentList[0].eway_bill_number;
    })
    .catch(err => {
      console.error(err);
    });
  }

  // Added by priya - 23/01/2026 - Generating eway bill part B - cn(PRIYA-JAN26-013)
  FilePartB(){
    const ewayVehicle = (this.ewayData.vehicleNo || '').toString().trim().toUpperCase();
    const partBVehicle = (this.EwayConsignmentList[0].VehicleNumber || '').toString().trim().toUpperCase();
    // if (ewayVehicle !== partBVehicle) {
    //   this.toastr.warning('Vehicle no not match with Eway ulip vehicle');
    //   return;
    // }
    return this.Eway.GenerateEwayPartB(this.EwayConsignmentList, this.userId, this.BookingIdForConsignmentProduct, this.ConsignmentDetailIdForConsignmentProduct).then(res => {
      if (res.success) {
        this.toastr.success('PartB Generated Successfully!');
      } else {
        this.toastr.warning(res.errorMessage);
      }
    }).catch(err => {
      return Promise.resolve();
    });
  }

  // Added by priya - 23/01/2026 - Download eway bill - cn(PRIYA-JAN26-013)
  // PrintEwayBill() {
  //   var ewayBillNo = this.loadedData.eWayBillNo;
  //   this.Eway.PrintEwayBill(ewayBillNo, this.EwayConsignmentList[0].TransporterGST, this.userId, this.BookingIdForConsignmentProduct).then(response => {
  //     this.DownloadFile(response);
  //   })
  //   .catch(err => {
  //     console.error(err);
  //   });
  // }

  // Added by priya - 23/01/2026 - Download eway bill - cn(PRIYA-JAN26-013)
  PrintAllEwayBills() {
    // this.Eway.GetEwayLrData(this.BookingId, this.ConsignmentDetailId).then(data => {
    //   this.EwayConsignmentList = data;
    //   setTimeout(() => {
    //     if (this.EwayConsignmentList && this.EwayConsignmentList.length > 0) {
    //       this.EwayConsignmentList.forEach((item) => {
    //         if (item.EWayBillUrl !== null) {
    //           window.open(item.EWayBillUrl, "_blank");
    //         } else {
    //           this.toastr.warning('Eway bill url is not available')
    //         }
    //       });
    //     }
    //   }, 300);
    // })
    // .catch(err => {
    //   console.error(err);
    // });
    // added by priya - 28/01/2026 - changed function for print eway bill - cn(PRIYA-JAN26-014)
    let EwayBillNo = this.loadedData.eWayBillNo || this.EwayBillNo
    this.Eway.GetVerifiedEwayBillData(this.ConsignmentDetailId, EwayBillNo).then(data => {
      if (data) {
        this.EwayData = data;
        setTimeout(() => {
          if (this.EwayData && this.EwayData.length > 0) {
            this.EwayData.forEach((item) => {
              if (item.eWayBillDocUrl !== null && item.eWayBillDocUrl !=='https://') {
                window.open(item.eWayBillDocUrl, "_blank");
              } else {
                this.toastr.warning('Eway bill url is not available')
              }
            });
          }
        }, 300);
      } else { // Added by priya - 22/04/2026 - cn(PRIYA-APR26-010)
        this.toastr.warning('No data available for the given ewaybill no')
      }
    })
    .catch(err => {
      console.error(err);
    });
  }

  // Added by priya - 23/01/2026 - Download eway bill - cn(PRIYA-JAN26-013)
  DownloadFile(FileContent) {
    var byteNumbers = new Array(FileContent.Content.length);
    for (var i = 0; i < FileContent.Content.length; i++) {
      byteNumbers[i] = FileContent.Content.charCodeAt(i);
    }
    var blob = this.commonService.b64toBlob(
      FileContent.Content,
      FileContent.ContentType
    );
    let url = window.URL.createObjectURL(blob);
    $("#DownLoadEwayReport").attr("href", url);
    $("#DownLoadEwayReport").attr("download", FileContent.FileName);
    let element: HTMLElement = document.getElementById(
      "DownLoadEwayReport"
    ) as HTMLElement;
    element.attributes;
    element.click();
  }

  // Added by priya - 24/01/2026 - Update ewabill in change transporter, driver and vehicle modal
  UpdateEwayFilePartB(){
    if (this.EwayBillNo == null) {
      this.toastr.warning('Eway Bill no is missing');
      return;
    }
    this.EwayConsignmentList[0].eway_bill_number = this.EwayBillNo;
    this.EwayConsignmentList[0].vehicle_number = this.dataY.VehicleNo;
    return this.Eway.GenerateEwayPartB(this.EwayConsignmentList, this.userId, this.dataY.BookingId, this.dataY.ConsignmentDetailId).then(res => {
      // return Promise.resolve();
      if (res.success) {
        this.toastr.success('E-Waybill updated successfully!');
      } else {
        this.toastr.warning(res.errorMessage);
      }
    }).catch(err => {
      return Promise.resolve();
    });
  }

  // Added by priya - 27/01/2026 - verify eway bill - cn(PRIYA-JAN26-014)
  VerifyEwayBill() {
    if (this.loadedData.eWayBillNo == null || this.loadedData.eWayBillNo == 'null' || this.loadedData.eWayBillNo == undefined){
      this.toastr.warning('Eway Bill no is missing')
      return;
    }
    var ewayBillNo = this.loadedData.eWayBillNo;
    this.loadedData.eWayBillExpDate = null;
    return this.Eway.VerifyEwayBill(ewayBillNo, this.CompanyGSTIN, this.userId, this.ConsignmentDetailId).then(res => {
      this.GetVerifiedEwayBillData(this.ConsignmentDetailId, ewayBillNo)
      this.GetEwayLrData(this.BookingId, this.ConsignmentDetailId);
      // this.IsValidateEwayUlip = true;
      // if (res && res[0].resultObj){
      //   const input = res[0].resultObj.eway_bill_valid_date;
      //   // "23/01/2026 05:59:00 PM"
      //   const [datePart, timePart, meridian] = input.split(' ');
      //   const [day, month, year] = datePart.split('/');
      //   let [hours, minutes, seconds] = timePart.split(':').map(Number);

      //   // convert to 24-hour format
      //   if (meridian === 'PM' && hours < 12) hours += 12;
      //   if (meridian === 'AM' && hours === 12) hours = 0;

      //   const formattedDate = `${year}-${month}-${day}T${String(hours).padStart(2, '0')}:${minutes}:${seconds}`;

      //   this.loadedData.eWayBillExpDate = formattedDate;
      //   // this.loadedData.eWayBillExpDate = res[0].resultObj.eway_bill_valid_date;
      //   this.IsVerifiedEway = true;
      // }
      return Promise.resolve();
    }).catch(err => {
      return Promise.resolve();
    });
  }

  // Added by priya - 27/01/2026 - getting verified eway bill data from db - cn(PRIYA-JAN26-014)
  GetVerifiedEwayBillData(ConsignmentDetailId, EwayBillNo) {
    this.CheckDuplicateEwayBillNo();
    this.ewayBillExpiryDays = null;
    this.Eway.GetVerifiedEwayBillData(ConsignmentDetailId, EwayBillNo).then(data => {
      if(data && data[0]){
        this.IsValidateEwayUlip = true;
        this.EwayData = data[0];
        this.loadedData.eWayBillExpDate = this.EwayData.eWayBillExpiryDate;
        this.ewayBillExpiryDays = this.EwayData.ewayBillExpiryDays;
        this.IsEwayPartBFiled = this.EwayData.IsEwayPartBFiled;
        if (this.EwayData.IsEwayBillVerified == 'Verified'){
          this.IsVerifiedEway = true;
        } else {
          this.IsVerifiedEway = false;
        }
      } else {
        this.IsValidateEwayUlip = false;
      }
    })
    .catch(err => {
      this.IsValidateEwayUlip = false;
      console.error(err);
    });
  }

  // Added by priya - 22/01/2026 - getting system setting value for Eway bill functionality - cn(PRIYA-JAN26-013)
  LoadEwayBillFiling() {
    this._appService.GetById("Common", "GetSystemSettingByName", "EwayBillFiling").subscribe((response) => {
      if (response == '1') {
        this.EwayBillFiling = true;
      } else {
        this.EwayBillFiling = false;
      }
      localStorage.setItem('EwayBillFiling', response);
    },
      (err) => {
        this.toastr.error("Error occurred while fetching Status data !", "error");
      });
  }

  // Added by priya - 30/01/2026 - Extend eway validity - cn(PRIYA-JAN26-015)
  ExtendEwayValidity() {
    this.isEwayFormSubmit = true;
    if (this.ValidateEwayFieldData()){
      // Added by priya - 03/02/2026 - sending selected value - cn(PRIYA-JAN26-016)
      this.EwayConsignmentList[0].RemainingDistance = this.EwayValidityData.EwayDistance;
      this.EwayConsignmentList[0].ValidityReason = this.EwayValidityData.EwayReasonName;
      this.EwayConsignmentList[0].ExtendRemarks = this.EwayValidityData.EwayRemark;
      return this.Eway.ExtendEwayValidity(this.EwayConsignmentList, this.userId, this.BookingIdForConsignmentProduct, this.ConsignmentDetailIdForConsignmentProduct).then(res => {
        if (res.success) {
          this.toastr.success('EWay Bill Validity Extended Successfully!');
          this.closeEwayModal();
        } else {
          this.toastr.warning(res.errorMessage);
        }
      }).catch(err => {
        return Promise.resolve();
      });
    }
  }

  // Added by priya - 31/01/2026 - check duplicate eway bill no - cn(PRIYA-JAN26-015)
  CheckDuplicateEwayBillNo() {
    let EwayBillNo = this.loadedData.eWayBillNo || this.EwayBillNo
    this.Eway.CheckDuplicateEwayBillNo(this.ConsignmentDetailId, EwayBillNo).then(data => {
      if (data[0]){
        this.IsEwayBillNoExists = data[0].IsDuplicateEway;
      }
    })
  }

  // Added by priya - 03/03/2026 - open Extend eway validity modal - cn(PRIYA-JAN26-016)
  OpenExtendEway() {
    this.GetValidityReason();
    this.modalEwayExtend = this.modalService.open(this.ExtendEway, { centered: true, size: "lg", backdrop: 'static', keyboard: false, windowClass: "ExtendEwayModal" });
  }

  // Added by priya - 03/02/2026 - cn(PRIYA-JAN26-016)
  closeEwayModal(){
    this.modalEwayExtend.close();
  }

  // Added by priya - 03/02/2026 - Getting eway validity reason dropdownlist values - cn(PRIYA-JAN26-016)
  GetValidityReason() {
    this.Eway.GetValidityReason().then(data => {
      if (data.length > 0) {
        this.EwayReason.dropdownList = data || [];
      }
    })
  }

  // Added by priya - 03/02/2026 - cn(PRIYA-JAN26-016)
  getEwayChangedValue(value, data) {
    const newValue = value && typeof value === 'object' && 'value' in value ? value.value : value;
    if (data.dataField == 'EwayReason'){
      let selectedItem = data.dropdownList.find(item => item.value === value);
      this.EwayValidityData[data.dataField] = newValue;
      this.EwayValidityData.EwayReasonName = selectedItem.name;
    } else if (newValue) {
      this.EwayValidityData[data.dataField] = newValue;
    }
  }

  // Added by priya - 03/02/2026 - Validation for required field - cn(PRIYA-JAN26-016)
  ValidateEwayFieldData() {
    var IsAllDataDone: any = true;
    if (!this.EwayValidityData.EwayDistance) {
      IsAllDataDone = false;
    }
    if (!this.EwayValidityData.EwayReason) {
      IsAllDataDone = false;
    }
    if (!this.EwayValidityData.EwayRemark) {
      IsAllDataDone = false;
    }
    if (!IsAllDataDone) {
      var RequiredError = this.translate.instant("DriverDetailsById.RequiredError");
      this.toastr.error(RequiredError, "error");
    }
    return IsAllDataDone;
  }

  MakeToOrderAutoGeneratePO: boolean = false;
  LoadMakeToOrderAutoGeneratePO() {
    this._appService
      .GetById("Common", "GetSystemSettingByName", "MakeToOrderAutoGeneratePO")
      .subscribe(
        (response) => {
          if (response == '1') {
            this.MakeToOrderAutoGeneratePO = true;
          } else {
            this.MakeToOrderAutoGeneratePO = false;
            
            this.shipmentProductDetails.tableDetails.columnDetails = this.shipmentProductDetails.tableDetails.columnDetails.filter(x => x.columnName != 'Sub Center');
            this.shipmentProductDetails.tableDetails.footerData = this.shipmentProductDetails.tableDetails.footerData.filter(x => x.productUIValue != 'Freight' && x.productUIValue != 'Insurance');

            this.shipmentInvoiceProductDetls.tableDetails.columnDetails = this.shipmentInvoiceProductDetls.tableDetails.columnDetails.filter(x => x.columnName != 'Sub Center');
            this.shipmentInvoiceProductDetls.tableDetails.footerData = this.shipmentInvoiceProductDetls.tableDetails.footerData.filter(x => x.OrderNo != 'Freight' && x.OrderNo != 'Insurance');
          }

          if(this.MakeToOrderAutoGeneratePO){
            const columnDetails = this.shipmentProductDetails.tableDetails.columnDetails;
            const productCol = columnDetails.find(col => col.dataFieldName === 'productUIValue');
            const mrpCol = columnDetails.find(col => col.columnName === 'MRP/Pc');
            if (productCol) productCol.columnName = 'Product Code/Name';
            if (mrpCol) mrpCol.columnName = 'Margin';

            const columnDetailsinv = this.shipmentInvoiceProductDetls.tableDetails.columnDetails;
            const productColinv = columnDetailsinv.find(col => col.dataFieldName === 'productUIValue');
            const mrpColinv = columnDetailsinv.find(col => col.columnName === 'MRP/Pc');
            if (productColinv) productColinv.columnName = 'Product Code/Name';
            if (mrpColinv) mrpColinv.columnName = 'Margin';

            const table = this.shipmentInvoiceProductDetls.tableDetails;
            table.footerData.forEach(row => {
              delete row.fulFilledQty;
              delete row.balanceQty;
            });

            const hideColumns = ['fulFilledQty','balanceQty'];
            table.columnDetails = table.columnDetails.filter(col =>
              !hideColumns.includes(col.dataFieldName)
            );

            const hideFooter = ['Discount','Taxable Amount','CGST','SGST','IGST','CESS'];
            table.footerData = table.footerData.filter(row => !hideFooter.includes(row.OrderNo));
            table.footerData.forEach(row => {
              delete row.CustomAmount;
            });

          }

          if (!this.MakeToOrderAutoGeneratePO) {
            const table = this.shipmentInvoiceProductDetls.tableDetails;
            const hideColumns = ['CustomRate','CustomAmount','FinalShiptoName','TotalShippingCost','TotalPurchase','TotalSale','SalePurchaseDiff'];
            table.columnDetails = table.columnDetails.filter(col =>
              !hideColumns.includes(col.dataFieldName) && col.columnName !== 'Actions'
            );

            const hideFooter = ['Freight','Insurance','USD to AUD Ex-Rate'];
            table.footerData = table.footerData.filter(row => !hideFooter.includes(row.OrderNo));
            table.footerData.forEach(row => {
              delete row.CustomAmount;
            });

            const columnDetailsinv = this.shipmentInvoiceProductDetls.tableDetails.columnDetails;
            const rateinv = columnDetailsinv.find(col => col.dataFieldName === 'rate');
            const Amountinv = columnDetailsinv.find(col => col.dataFieldName === 'amount');
            if (rateinv) rateinv.columnName = 'Rate/Pc';
            if (Amountinv) Amountinv.columnName = 'Amount';
          }

        },
        (err) => {
          this.toastr.error(
            "Error occurred while fetching Status data !",
            "error"
          );
        }
      );
  }

  GetShipmentDataById(OrderId) {
    this._appService.GetByTwoId("OrdersByVehicle", "GetShipmentDataById", OrderId, this.CompanyId).subscribe(
    (response) => {
      if(response){
        this.shipmentProductDetails.tableDetails.data=[];
        this.portData={};
        if (!response || !response.Table || response.Table.length === 0) {
          return;
        }
        this.portData = response.Table1[0] || {}
        const table = this.shipmentProductDetails.tableDetails;
        const footer = table.footerData;
        const ExchangeRate = response.Table[0].ExchangeRate || 1;
        table.data = [];
        this.resetFooter(footer);
        for (const item of response.Table) {
        const obj: any = this.mapShipmentItem(item);
        table.data.push(obj);

        this.updateQtyFooter(footer, obj);

        // if (this.MakeToOrderAutoGeneratePO) {
        // this.updatePOFooter(footer, obj, ExchangeRate);
        // } else {
        // }
        this.updateNormalFooter(footer, obj, ExchangeRate);
        }
      }
    },
    (error)=>{
      console.error('Error while getting Shipment Data');
    }
    );
  }
  
  mapShipmentItem(item: any) {
    return {
      productId: item.Product,
      productPackingId: item.productPackingId,
      productUIValue: item.productUIValue,
      code: item.name,
      name: item.ProductName,
      description: item.ProductDesc,
      unitId: item.Unit,
      unit: item.UnitName,
      weight: item.weight,
      totalWeight: item.totalWeight,
      caseSize: item.caseSize,
      qty: item.Qty,
      fulFilledQty: item.AllocateQty,
      balanceQty: item.BalanceQty,
      caseQty: item.caseQty,
      MRP: this.toFixed(item.MRP),
      rate: this.toFixed(item.UnitPrice),
      amount: this.toFixed(item.netAmount),
      discount: this.toFixed(item.Discount),
      netAmount: this.toFixed(item.InvoiceAmount),
      taxRate: item.TaxRate,
      taxId: item.taxId,
      CessId: item.CessId,
      CessRate: item.CessRate,
      cgstAmount: item.cgstAmount,
      sgstAmount: item.sgstAmount,
      igstAmount: item.igstAmount,
      cessAmount: item.cessAmount,
      mfgDate: item.MfgDate,
      expDate: item.ExpDate,
      FinalShipto: item.FinalShipto,
      FinalShiptoName: item.FinalShiptoName,
      InwardRate: item.InwardRate,
      InwardExpPerQty: item.InwardExpPerQty,
      ExchangeRate: item.ExchangeRate,
      RateWithExp: item.RateWithExp,
      OrderNo: item.OrderNo,
      TotalShippingCost: item.TotalShippingCost,
      InvoiceNumber: item.InvoiceNumber,
      BookingId: item.BookingId,
      OrderId: item.OrderId,
      InwardRateWithExpense : item.InwardRateWithExpense,
      Margin : item.Margin,
      MarginAmount : item.MarginAmount,
      SellRateCurrency : item.SellRateCurrency,
      TotalShippingCharges : item.TotalShippingCharges,
      freightAmount : item.freightAmount,
      insuranceAmount : item.insuranceAmount,
      UsdAudRate : item.UsdAudRate,
      ConsignmentDetailId : item.ConsignmentDetailId
    };
  }

  updateQtyFooter(footer, obj) {
    footer[0].qty = this.add(footer[0].qty, obj.qty);
    footer[0].fulFilledQty = this.add(footer[0].fulFilledQty, obj.fulFilledQty, 0);
    footer[0].balanceQty = this.add(footer[0].balanceQty, obj.balanceQty, 0);
    footer[0].amount = this.add(footer[0].amount, obj.amount);
  }

  updatePOFooter(footer, obj, rate) {
    footer[2].amount = obj.freightAmount ? obj.freightAmount : 0;
    footer[3].amount = obj.insuranceAmount ? obj.insuranceAmount : 0;

    footer[4].amount = this.add(footer[4].amount, obj.netAmount);
    footer[5].amount = this.add(footer[5].amount, obj.cgstAmount);
    footer[6].amount = this.add(footer[6].amount, obj.sgstAmount);
    footer[7].amount = this.add(footer[7].amount, obj.igstAmount);
    footer[8].amount = this.add(footer[8].amount, obj.cessAmount);

    let total =
      parseFloat(footer[4].amount) +
      parseFloat(footer[5].amount) +
      parseFloat(footer[6].amount) +
      parseFloat(footer[7].amount) +
      parseFloat(footer[8].amount);

    footer[10].amount = total.toFixed(2);
    footer[9].amount = (Math.round(total) - total).toFixed(2);
    footer[10].amount = Math.round(total).toFixed(2);
    footer[11].amount = (parseFloat(footer[10].amount) * parseFloat(rate)).toFixed(2);
  }

  updateNormalFooter(footer, obj, rate) {
    footer[2].amount = this.add(footer[2].amount, obj.netAmount);
    footer[3].amount = this.add(footer[3].amount, obj.cgstAmount);
    footer[4].amount = this.add(footer[4].amount, obj.sgstAmount);
    footer[5].amount = this.add(footer[5].amount, obj.igstAmount);
    footer[6].amount = this.add(footer[6].amount, obj.cessAmount);

    let total =
      parseFloat(footer[2].amount) +
      parseFloat(footer[3].amount) +
      parseFloat(footer[4].amount) +
      parseFloat(footer[5].amount) +
      parseFloat(footer[6].amount);

    footer[8].amount = total.toFixed(2);
    footer[7].amount = (Math.round(total) - total).toFixed(2);
    footer[8].amount = Math.round(total).toFixed(2);
    footer[9].amount = (parseFloat(footer[8].amount) * parseFloat(rate)).toFixed(2);
  }

  toFixed(value: any, digit = 2) {
    return parseFloat(value || 0).toFixed(digit);
  }

  add(a: any, b: any, digit = 2) {
    return (parseFloat(a || 0) + parseFloat(b || 0)).toFixed(digit);
  }

  resetFooter(footer) {
    footer[0].qty = 0;
    footer[0].fulFilledQty = 0;
    footer[0].balanceQty = 0;
    footer[0].amount = 0;

    footer[2].amount = 0;
    footer[3].amount = 0;
    footer[4].amount = 0;
    footer[5].amount = 0;
    footer[6].amount = 0;

    footer[7].amount = 0;
    footer[8].amount = 0;
    footer[9].amount = 0;
    // if (this.MakeToOrderAutoGeneratePO) {
    //   footer[10].amount = 0;
    //   footer[11].amount = 0;
    // }
  }

  receiveExchangeRate(event){
    console.log('receiveExchangeRate',event ,typeof event);
    this.UpdateExchangeRateDataevent(event);
  }

  UpdateExchangeRateDataevent(ExchangeRate){
    let obj:any={};
    obj.Id = this.SelectedId;
    obj.ExchangeRate = ExchangeRate;
    obj.UserId = this.userId;
    obj.InvoiceNo = this.InvoiceNos;
    this._appService.Post('OrdersByVehicle','UpdateExchangeRate',obj).subscribe(
      (response)=>{
          console.log('Updated successfully!');
          this.UpdateDispatchByExRate(ExchangeRate);
      },
      (error)=>{
          console.error('Error while updating exchange rate');
      }
    )
  }

  onActionClick({ row, actionName, index }) {
    if (actionName.trim() == "EditRow") {
      
      if (this.commonService.CheckHasRight("UpdateMargin", "ORDER_LTL_DETAILS")) {
        row.IsEditRow = true;
        const mrpColumn = this.shipmentInvoiceProductDetls.tableDetails.columnDetails.find(col => col.columnName === "Margin");

        if (mrpColumn) {
          mrpColumn.rowEditInput = true;
          mrpColumn.inputField = {
            placeholder: 'Enter Margin',
            formControlName: 'MRP',
            dataField: 'MRP',
            type: "number",
            alignType: 'right',
            isReadOnly: false
          }
        }
      }

    } else if (actionName.trim() == "CloseRow") {
      row.IsEditRow = false;
    } else if (actionName.trim() == "Update") {
      if (this.commonService.CheckHasRight("UpdateMargin", "ORDER_LTL_DETAILS")) {
        this.UpdateMRPRate(row);
      }
      row.IsEditRow = false;
    } else if (actionName.trim() == "Print Invoice Custom") { 
      this.PrintInvCust(row.OrderId, row.InvoiceNo, row.ConsignmentDetailId,row.BookingId); 
    } else  if(actionName.trim() =='Print Invoice Client Copy'){
      this.PrintInvClient(row.OrderId, row.InvoiceNo, row.ConsignmentDetailId,row.BookingId); 
    }
  }

  onCheckSelect({ event, row, index, type, dataFieldName }) {
    if (type == 'Input') {
      if (dataFieldName == 'MRP') {
        let marginPercent=0;
        let currentRate=0;
        let currentPurRate=0;
        let currentQty=0;
        let marginAmount=0;
        let InwardExpPerQty=0;
        let ExchangeRate=0;
        let RateWithExp=0;
        let TotalSell=0;
        let TotalSellPriceInCurrency=0;

        let InwardRateWithExpense=0;
        let Margin=0;
        let MarginAmount=0;
        let SellRateCurrency=0;
        let TotalShippingCharges=0;
        let TotalShippingCost=0;

        marginPercent = parseFloat(event || 0);
        currentRate = parseFloat((row && row.rate) || 0);
        currentPurRate = parseFloat((row && row.InwardRate) || 0);
        InwardExpPerQty = parseFloat((row && row.InwardExpPerQty) || 0);
        ExchangeRate = parseFloat((row && row.ExchangeRate) || 1);
        RateWithExp = parseFloat((row && row.RateWithExp) || 0);
        currentQty = parseFloat((row && row.qty) || 0);

        InwardRateWithExpense = parseFloat((row && row.InwardRateWithExpense) || 0);
        Margin = parseFloat((row && row.Margin) || 0);
        MarginAmount = parseFloat((row && row.MarginAmount) || 0);
        SellRateCurrency = parseFloat((row && row.SellRateCurrency) || 0);
        TotalShippingCharges = parseFloat((row && row.TotalShippingCharges) || 0);
        TotalShippingCost = parseFloat((row && row.TotalShippingCost) || 0);

        marginPercent = isNaN(marginPercent) ? 0 : marginPercent;
        currentRate = isNaN(currentRate) ? 0 : currentRate;
        currentPurRate = isNaN(currentPurRate) ? 0 : currentPurRate;
        InwardExpPerQty = isNaN(InwardExpPerQty) ? 0 : InwardExpPerQty;
        ExchangeRate = isNaN(ExchangeRate) ? 1 : ExchangeRate;
        RateWithExp = isNaN(RateWithExp) ? 0 : RateWithExp;
        currentQty = isNaN(currentQty) ? 0 : currentQty;
        
        InwardRateWithExpense = isNaN(InwardRateWithExpense) ? 0 : InwardRateWithExpense;
        Margin = isNaN(Margin) ? 0 : Margin;
        MarginAmount = isNaN(MarginAmount) ? 0 : MarginAmount;
        SellRateCurrency = isNaN(SellRateCurrency) ? 0 : SellRateCurrency;
        TotalShippingCharges = isNaN(TotalShippingCharges) ? 0 : TotalShippingCharges;
        TotalShippingCost = isNaN(TotalShippingCost) ? 0 : TotalShippingCost;


        marginAmount = (RateWithExp * marginPercent) / 100;
        TotalSell = RateWithExp + marginAmount;
        TotalSellPriceInCurrency = parseFloat((TotalSell / ExchangeRate).toFixed(2));


        InwardRateWithExpense = RateWithExp;
        Margin =  marginPercent;
        MarginAmount =  marginAmount; 
        SellRateCurrency = TotalSellPriceInCurrency;
        TotalShippingCharges = TotalShippingCost;

        console.log('Inward rate',currentPurRate);
        console.log('InwardExpPerQty',InwardExpPerQty);
        console.log('RateWithExp',RateWithExp);
        console.log('marginAmount',marginAmount);
        console.log('TotalSell',TotalSell);
        console.log('TotalSellPriceInCurrency',TotalSellPriceInCurrency);
        this.shipmentInvoiceProductDetls.tableDetails.data[index].MRP = marginPercent;
        this.shipmentInvoiceProductDetls.tableDetails.data[index].InwardRateWithExpense = InwardRateWithExpense;
        this.shipmentInvoiceProductDetls.tableDetails.data[index].Margin = Margin;
        this.shipmentInvoiceProductDetls.tableDetails.data[index].MarginAmount = MarginAmount;
        this.shipmentInvoiceProductDetls.tableDetails.data[index].SellRateCurrency = SellRateCurrency;
        this.shipmentInvoiceProductDetls.tableDetails.data[index].TotalShippingCharges = TotalShippingCharges;
        // this.shipmentProductDetails.tableDetails.data[index].amount = marginAmount;
      }
      if(dataFieldName == 'USDtoAUD'){
        let USDtoAUD=0;
        USDtoAUD = parseFloat(event);
        this.UpdateUsdAudRate(USDtoAUD);
      }
    }
  }

  UpdateMRPRate(row: any){
    if (!row.MRP) {
      this.toastr.warning("Please Enter Margin.", "error");
      return;
    }
    if (parseFloat(row.MRP) <= 0) {
      this.toastr.warning("Margin should be grater than zero.", "error");
      return;
    }

    var obj: any = {};
    obj.OrderId = row.OrderId;
    obj.BookingId = row.BookingId;
    obj.InvoiceNo = row.InvoiceNumber;
    obj.UserId = this.userId;
    obj.ProductId = row.productId;
    obj.FinalShipto = row.FinalShipto;
    obj.InwardRateWithExpense = row.InwardRateWithExpense; 
    obj.Margin = row.Margin;
    obj.MarginAmount = row.MarginAmount;
    obj.SellRateCurrency = row.SellRateCurrency;
    obj.TotalShippingCharges = row.TotalShippingCharges;
    obj.Qty = row.qty;

    this._appService.Post("so_GoodsOutward", "UpdateShipmentInvoiceData", obj).subscribe(
      (response) => {
        Helpers.setLoading(false);
        this.toastr.success("Data save successfully", "success");
        this.GetShipmentInvoiceDataById();
      },
      (err) => {
        this.toastr.error('Error while save data.', "error");
        Helpers.setLoading(false);
      }
    );
  }

  
  GetShipmentInvoiceDataById() {
    this._appService.GetByTwoId("OrdersByVehicle", "GetShipmentInvoiceDataById", this.NewBookingId, this.InvoiceNos).subscribe(
    (response) => {
      if(response){
        this.shipmentInvoiceProductDetls.tableDetails.data=[];
        if (!response || !response.Table || response.Table.length === 0) {
          return;
        }
        const table = this.shipmentInvoiceProductDetls.tableDetails;
        const footer = table.footerData;
        const ExchangeRate = response.Table[0].ExchangeRate || 1;
        const invoiceno = response.Table[0].InvoiceNumber;
        const isInvoiceGenerate = response.Table[0].isInvoiceGenerate;

        if (ExchangeRate !== null && ExchangeRate !== undefined && ExchangeRate !== 0 && this.data && this.data.Order) {
          this.data.Order.ExchangeRate = ExchangeRate;
        }

        if (invoiceno !== null && invoiceno !== undefined && this.data && this.data.Order) {
          this.data.Order.orderInvoiceNumber = invoiceno;
        }

        if (isInvoiceGenerate !== null && isInvoiceGenerate !== undefined && this.data && this.data.Order) {
          this.data.Order.isInvoiceGenerate = isInvoiceGenerate;
        }

        table.data = [];
        this.resetFooters(footer);
        for (const item of response.Table) {
        const obj: any = this.mapShipmentItem(item);
        table.data.push(obj);

        this.updateQtyFooterForInvDet(footer, obj);

        if (this.MakeToOrderAutoGeneratePO) {
        this.updatePremvatiFooter(footer, obj, ExchangeRate);
        } else {
        this.updateNormalFooters(footer, obj, ExchangeRate);
        }
      }
      if(this.MakeToOrderAutoGeneratePO){
        this.addCustomRate();
        this.FooterCustomAmount();
      }
      }
    },
    (error)=>{
      console.error('Error while getting Shipment Data');
    }
    );
  }

  UpdateDispatchByExRate(ExchangeRate){
    var obj: any = {};
    obj.OrderId = this.SelectedId;
    obj.BookingId = null;
    obj.InvoiceNo = this.InvoiceNos;
    obj.UserId = this.userId;
    obj.ExchangeRate = ExchangeRate;

    this._appService.Post("so_GoodsOutward", "UpdateOrderDispatchDataOnExchangeRateChange", obj).subscribe(
      (response) => {
        Helpers.setLoading(false);
        this.toastr.success("Data save successfully", "success");
        this.GetShipmentInvoiceDataById();
      },
      (err) => {
        this.toastr.error('Error while save data.', "error");
        Helpers.setLoading(false);
      }
    );
  }

  updateQtyFooterForInvDet(footer, obj) {
    footer[0].qty = this.add(footer[0].qty, obj.qty);
    footer[0].amount = this.add(footer[0].amount, obj.amount);
    if (!this.MakeToOrderAutoGeneratePO) {
      footer[0].fulFilledQty = this.add(footer[0].fulFilledQty, obj.fulFilledQty, 0);
      footer[0].balanceQty = this.add(footer[0].balanceQty, obj.balanceQty, 0);
    }
  }

  updatePOFooterForInvDet(footer, obj, rate) {
    footer[2].amount = obj.freightAmount ? obj.freightAmount : 0;
    footer[3].amount = obj.insuranceAmount ? obj.insuranceAmount : 0;
    footer[4].amount = obj.UsdAudRate ? obj.UsdAudRate : 0;

    footer[5].amount = this.add(footer[5].amount, obj.netAmount);
    footer[6].amount = this.add(footer[6].amount, obj.cgstAmount);
    footer[7].amount = this.add(footer[7].amount, obj.sgstAmount);
    footer[8].amount = this.add(footer[8].amount, obj.igstAmount);
    footer[9].amount = this.add(footer[9].amount, obj.cessAmount);

    let total =
      parseFloat(footer[5].amount) +
      parseFloat(footer[6].amount) +
      parseFloat(footer[7].amount) +
      parseFloat(footer[8].amount) +
      parseFloat(footer[9].amount);

    footer[11].amount = total.toFixed(2);
    footer[10].amount = (Math.round(total) - total).toFixed(2);
    footer[11].amount = Math.round(total).toFixed(2);
    footer[12].amount = (parseFloat(footer[11].amount) * parseFloat(rate)).toFixed(2);
  }

  updateNormalFooterForInvDet(footer, obj, rate) {
    footer[2].amount = this.add(footer[2].amount, obj.netAmount);
    footer[3].amount = this.add(footer[3].amount, obj.cgstAmount);
    footer[4].amount = this.add(footer[4].amount, obj.sgstAmount);
    footer[5].amount = this.add(footer[5].amount, obj.igstAmount);
    footer[6].amount = this.add(footer[6].amount, obj.cessAmount);

    let total =
      parseFloat(footer[2].amount) +
      parseFloat(footer[3].amount) +
      parseFloat(footer[4].amount) +
      parseFloat(footer[5].amount) +
      parseFloat(footer[6].amount);

    footer[8].amount = total.toFixed(2);
    footer[7].amount = (Math.round(total) - total).toFixed(2);
    footer[8].amount = Math.round(total).toFixed(2);
    footer[9].amount = (parseFloat(footer[8].amount) * parseFloat(rate)).toFixed(2);
  }

  resetFooterForInvDet(footer) {
    footer[0].qty = 0;
    footer[0].fulFilledQty = 0;
    footer[0].balanceQty = 0;
    footer[0].amount = 0;

    footer[2].amount = 0;
    footer[3].amount = 0;
    footer[4].amount = 0;
    footer[5].amount = 0;
    footer[6].amount = 0;

    footer[7].amount = 0;
    footer[8].amount = 0;
    footer[9].amount = 0;
    if (this.MakeToOrderAutoGeneratePO) {
      footer[10].amount = 0;
      footer[11].amount = 0;
      footer[12].amount = 0;
    }
  }

  addCustomRate(){
    this.shipmentInvoiceProductDetls.tableDetails.data.forEach(ele => {
      const shippingCost = Number(ele.TotalShippingCost) || 0;
      const unitPrice = Number(ele.rate) || 0;
      const exchangeRate = Number(ele.ExchangeRate) || 1;

      ele.CustomRate = (shippingCost + unitPrice).toFixed(2);
      ele.CustomAmount = (ele.CustomRate * ele.qty).toFixed(2);
      ele.TotalPurchase = (ele.RateWithExp * ele.qty).toFixed(2);
      ele.TotalSale = (unitPrice * ele.qty * exchangeRate).toFixed(2);
      ele.SalePurchaseDiff = (ele.TotalSale - ele.TotalPurchase).toFixed(2);
    });

    let totalCustomAmount = 0;

    let totalPurchase = 0;
    let totalSale = 0;
    let salePurchaseDiff = 0;

    this.shipmentInvoiceProductDetls.tableDetails.data.forEach(ele => {
      totalCustomAmount += Number(ele && ele.CustomAmount ? ele.CustomAmount : 0);

      totalPurchase += Number(ele && ele.TotalPurchase ? ele.TotalPurchase : 0);
      totalSale += Number(ele && ele.TotalSale ? ele.TotalSale : 0);
      salePurchaseDiff += Number(ele && ele.SalePurchaseDiff ? ele.SalePurchaseDiff : 0);
    });
    this.shipmentInvoiceProductDetls.tableDetails.footerData[0].CustomAmount = totalCustomAmount.toFixed(2);

    this.shipmentInvoiceProductDetls.tableDetails.footerData[0].TotalPurchase = totalPurchase.toFixed(2);
    this.shipmentInvoiceProductDetls.tableDetails.footerData[0].TotalSale = totalSale.toFixed(2);
    this.shipmentInvoiceProductDetls.tableDetails.footerData[0].SalePurchaseDiff = salePurchaseDiff.toFixed(2);
  }

  FooterCustomAmount() {
    const table = this.shipmentInvoiceProductDetls.tableDetails;
    const footer = table.footerData;
    
    const freight = this.getFooterRow(footer, 'Freight');
    const insurance = this.getFooterRow(footer, 'Insurance');
    const exrate = this.getFooterRow(footer, 'USD to AUD Ex-Rate');
    // const taxable = this.getFooterRow(footer, 'Taxable Amount');
    // const cgst = this.getFooterRow(footer, 'CGST');
    // const sgst = this.getFooterRow(footer, 'SGST');
    // const igst = this.getFooterRow(footer, 'IGST');
    // const cess = this.getFooterRow(footer, 'CESS');
    const round = this.getFooterRow(footer, 'Round off');
    const net = this.getFooterRow(footer, 'Net Amount');
    const local = this.getFooterRow(footer, 'Net Amount in Local Currency');

    let totalCustomAmount = 0;

    table.data.forEach(ele => {

      const shippingCost = Number(ele.TotalShippingCost) || 0;
      const unitPrice = Number(ele.rate) || 0;
      const qty = Number(ele.qty) || 0;

      const customRate = shippingCost + unitPrice;
      const customAmount = customRate * qty;

      ele.CustomRate = customRate.toFixed(2);
      ele.CustomAmount = customAmount.toFixed(2);

      totalCustomAmount += customAmount;

      // if (taxable) taxable.CustomAmount = this.add(taxable.CustomAmount, customAmount);
      // if (cgst) cgst.CustomAmount = this.add(cgst.CustomAmount, ele.cgstAmount);
      // if (sgst) sgst.CustomAmount = this.add(sgst.CustomAmount, ele.sgstAmount);
      // if (igst) igst.CustomAmount = this.add(igst.CustomAmount, ele.igstAmount);
      // if (cess) cess.CustomAmount = this.add(cess.CustomAmount, ele.cessAmount);

      if (net) {
        net.CustomAmount = this.add(net.CustomAmount, customAmount);
      }
      
      if (freight) freight.CustomAmount = ele.freightAmount ? ele.freightAmount : 0;
      if (insurance) insurance.CustomAmount = ele.insuranceAmount ? ele.insuranceAmount : 0;
      if (exrate) exrate.CustomAmount = ele.UsdAudRate ? ele.UsdAudRate : 0;


    });

    let total = parseFloat(net.CustomAmount) || 0;

    // let total = 0;
    // if (taxable) total += Number(taxable.CustomAmount) || 0;
    // if (cgst) total += Number(cgst.CustomAmount) || 0;
    // if (sgst) total += Number(sgst.CustomAmount) || 0;
    // if (igst) total += Number(igst.CustomAmount) || 0;
    // if (cess) total += Number(cess.CustomAmount) || 0;

    if (round) {
      round.CustomAmount = (Math.round(total) - total).toFixed(2);
    }

    if (net) {
      net.CustomAmount = Math.round(total).toFixed(2);
    }
    const rate = 1;
    if (local && net) {
      local.CustomAmount = (Number(net.CustomAmount) * rate).toFixed(2);
    }
  }

  UpdateUsdAudRate(UsdAudRate){
    let obj:any={
      InvoiceNo:this.InvoiceNos,
      UserId:this.userId,
      UsdAudRate:UsdAudRate,
    }
    this._appService.Post('so_GoodsOutward','UpdateUsdAudRate',obj).subscribe(
      (response)=>{
        console.log('Updated UsdAudRate !');
        this.GetShipmentInvoiceDataById();
      },
      (error)=>{
        console.error('error while Update UsdAudRate',error)
      }
    );
  }

  PrintInvCust(OrderId,InvoiceNo,ConsignmentDetailId,BookingId) {
    this.PrintFormatsChild.UserId = this.userId;
    this.PrintFormatsChild.CompanyId = this.CompanyId;
    this.PrintFormatsChild.OrderId = OrderId;
    this.PrintFormatsChild.InvoiceNo = this.InvoiceNos;
    this.PrintFormatsChild.ConsignmentDetailId = ConsignmentDetailId;
    this.PrintFormatsChild.BookingId = BookingId;
    this.PrintFormatsChild.obv_Print_PremvatiEInvoice();
  }

  PrintInvClient(OrderId,InvoiceNo,ConsignmentDetailId,BookingId) {
    this.PrintFormatsChild.UserId = this.userId;
    this.PrintFormatsChild.CompanyId = this.CompanyId;
    this.PrintFormatsChild.OrderId = OrderId;
    this.PrintFormatsChild.InvoiceNo = this.InvoiceNos;
    this.PrintFormatsChild.ConsignmentDetailId = ConsignmentDetailId;
    this.PrintFormatsChild.BookingId = BookingId;
    this.PrintFormatsChild.obv_Print_PremvatiEInvoiceClientCopy();
  }


  getFooterRow(footer, name) {
    return footer.find(x => x.OrderNo === name);
  }
  
  updatePremvatiFooter(footer, obj, rate) {
    const freight = this.getFooterRow(footer, 'Freight');
    const insurance = this.getFooterRow(footer, 'Insurance');
    const exrate = this.getFooterRow(footer, 'USD to AUD Ex-Rate');
    // const taxable = this.getFooterRow(footer, 'Taxable Amount');
    // const cgst = this.getFooterRow(footer, 'CGST');
    // const sgst = this.getFooterRow(footer, 'SGST');
    // const igst = this.getFooterRow(footer, 'IGST');
    // const cess = this.getFooterRow(footer, 'CESS');
    const round = this.getFooterRow(footer, 'Round off');
    const net = this.getFooterRow(footer, 'Net Amount');
    const local = this.getFooterRow(footer, 'Net Amount in Local Currency');

    if (freight) freight.amount = obj.freightAmount ? obj.freightAmount : 0;
    if (insurance) insurance.amount = obj.insuranceAmount ? obj.insuranceAmount : 0;
    if (exrate) exrate.amount = obj.UsdAudRate ? obj.UsdAudRate : 0;
    if (net) {
      net.amount = this.add(net.amount, obj.netAmount);
    }

    let total = parseFloat(net.amount) || 0;
    // taxable.amount = this.add(taxable.amount, obj.netAmount);
    // cgst.amount = this.add(cgst.amount, obj.cgstAmount);
    // sgst.amount = this.add(sgst.amount, obj.sgstAmount);
    // igst.amount = this.add(igst.amount, obj.igstAmount);
    // cess.amount = this.add(cess.amount, obj.cessAmount);

    // let total =
    //   parseFloat(taxable.amount) +
    //   parseFloat(cgst.amount) +
    //   parseFloat(sgst.amount) +
    //   parseFloat(igst.amount) +
    //   parseFloat(cess.amount);

    if (round) round.amount = (Math.round(total) - total).toFixed(2);
    if (net) net.amount = Math.round(total).toFixed(2);
    if (local) local.amount = (parseFloat(net.amount) * parseFloat(rate)).toFixed(2);
  }

  updateNormalFooters(footer, obj, rate) {
    const taxable = this.getFooterRow(footer, 'Taxable Amount');
    const cgst = this.getFooterRow(footer, 'CGST');
    const sgst = this.getFooterRow(footer, 'SGST');
    const igst = this.getFooterRow(footer, 'IGST');
    const cess = this.getFooterRow(footer, 'CESS');
    const round = this.getFooterRow(footer, 'Round off');
    const net = this.getFooterRow(footer, 'Net Amount');
    const local = this.getFooterRow(footer, 'Net Amount in Local Currency');

    taxable.amount = this.add(taxable.amount, obj.netAmount);
    cgst.amount = this.add(cgst.amount, obj.cgstAmount);
    sgst.amount = this.add(sgst.amount, obj.sgstAmount);
    igst.amount = this.add(igst.amount, obj.igstAmount);
    cess.amount = this.add(cess.amount, obj.cessAmount);

    let total =
      parseFloat(taxable.amount) +
      parseFloat(cgst.amount) +
      parseFloat(sgst.amount) +
      parseFloat(igst.amount) +
      parseFloat(cess.amount);

    if (round) round.amount = (Math.round(total) - total).toFixed(2);
    if (net) net.amount = Math.round(total).toFixed(2);
    if (local) local.amount = (parseFloat(net.amount) * parseFloat(rate)).toFixed(2);
  }

  resetFooters(footer) {
    if(this.MakeToOrderAutoGeneratePO){
      footer[0].qty = 0;
      footer[0].fulFilledQty = 0;
      footer[0].balanceQty = 0;
      footer[0].amount = 0;
      footer[0].CustomAmount = 0;

      footer[1].amount = 0;
      footer[1].CustomAmount = 0;

      footer[2].amount = 0;
      footer[2].CustomAmount = 0;

      footer[3].amount = 0;
      footer[3].CustomAmount = 0;

      footer[4].amount = 0;
      footer[4].CustomAmount = 0;

      footer[5].amount = 0;
      footer[5].CustomAmount = 0;

      footer[6].amount = 0;
      footer[6].CustomAmount = 0;

      // footer[7].amount = 0;
      // footer[7].CustomAmount = 0;

      // footer[8].amount = 0;
      // footer[8].CustomAmount = 0;

      // footer[9].amount = 0;
      // footer[9].CustomAmount = 0;

      // footer[10].amount = 0;
      // footer[10].CustomAmount = 0;

      // footer[11].amount = 0;
      // footer[11].CustomAmount = 0;

      // footer[12].amount = 0;
      // footer[12].CustomAmount = 0;
    } else{
      footer[0].qty = 0;
      footer[0].fulFilledQty = 0;
      footer[0].balanceQty = 0;
      footer[0].amount = 0;

      footer[2].amount = 0;
      footer[3].amount = 0;
      footer[4].amount = 0;
      footer[5].amount = 0;
      footer[6].amount = 0;

      footer[7].amount = 0;
      footer[8].amount = 0;
      footer[9].amount = 0;
    }
  }

  reportHeader: any = [];
  GetshipmentInvoiceDiff(){
    let obj:any={
      BookingId:this.NewBookingId, 
      InvoiceNo:this.InvoiceNos
    }
    this._appService.Post('so_GoodsOutward','GetshipmentInvoiceDiff',obj).subscribe(
      (response)=>{
        if (response.length) {
          let i = 0;
          response.forEach((value, prop, obj) => {
            if (i == 0) {
              delete value["Count"];
              this.reportHeader = Object.getOwnPropertyNames(value);
            }
            i++;
          });

          this.shipmentInvoiceDiff.tableDetails.columnDetails = [];
          for (const item of this.reportHeader) {
            var obj: any = {};
            obj.columnName = item;
            obj.dataFieldName = item;
            this.shipmentInvoiceDiff.tableDetails.columnDetails.push(obj);
          }
        }
        this.assignTableFields(0, 15, response)
      },
      (err)=>{
        this.toastr.error('','');
      } 
    );
  }

  assignTableFields(pageNo, perPage, data) {
    this.shipmentInvoiceDiff.tableDetails = {
      ...this.shipmentInvoiceDiff.tableDetails,
      data: data,
    }
  }

  switchTabInvoice(event) {
    if (event != null) {
      this.tabTitle = event.originalEvent.target.innerText;
    }
    if(this.tabTitle == 'Invoice Diff'){
      this.GetshipmentInvoiceDiff();
    }
  }

  // Added by priya - 02/04/2026 - cn(PRIYA-APR26-001)
  LoadSimTracking() {
    this._appService.GetById("Common", "GetSystemSettingByName", "SIMTracking").subscribe((response) => {
      if (response == '1') {
        this.IsSimTracking = true;
      } else {
        this.IsSimTracking = false;
      }
      localStorage.setItem('IsSimTracking', response);
    },
      (err) => {
        this.toastr.error("Error occurred while fetching Status data !", "error");
      });
  }

  //Added by BURHAN - 22-April-2026
  GetIsAutoNumberingFlag() {
    this._appService
      .GetById("InvoiceNumbering", "isAutoNumberingFlag", this.CompanyId)
      .subscribe(
        (response) => {
          console.log('Data for manual LR :',response);
          if (response != null) {
            this.isAutoNumberingFlag = response.isAutoNumberingFlag;
            this.GenerateManualLRNoIndent = response.isGenerateManualLRNoIndentFlag;
          } else {
            this.isAutoNumberingFlag = false;
            this.GenerateManualLRNoIndent = false;
          }
        },
        (err) => {
          this.toastr.error(
            "Error occurred while fetching Status data !",
            "error"
          );
        }
      );
  }
  //added - 6-May-2026
  openTripAttachment(tripId: any) {
    this.SelectedTripId = tripId; // Trip ID set karo
    this.isAttachmentShowForTrips = true; // Dialog kholo
    this.cdr.detectChanges(); // Change detection force karo agar zarurat pade
  }
  //added - 27-May-2026
  handleUpdateTracking(data: any) {
    this.currentTrackingData = data;
    this.trackingLinkValue = '';
    this.isUpdateTrackingMode = false;

    Helpers.setLoading(true);
    this._appService.GetById("OrdersByVehicle", "GetTrackingLink", data.ConsignmentDetailId || data.Id).subscribe(
      (response) => {
        Helpers.setLoading(false);

        if (response && response.length > 0 && response[0].VendorTrackingLink) {
          this.trackingLinkValue = response[0].VendorTrackingLink;
          this.isUpdateTrackingMode = true;
        }

        this.modalRef = this.modalService.open(this.updateTrackingModal, {
          size: "lg",
          windowClass: 'modal-top-slide',
          backdrop: 'static'
        });
      },
      (err) => {
        Helpers.setLoading(false);
        this.modalRef = this.modalService.open(this.updateTrackingModal, {
          size: "lg",
          windowClass: 'modal-top-slide',
          backdrop: 'static'
        });
      }
    );
  }

  saveTrackingLink() {
    const link = this.trackingLinkValue.trim() || '';

    const urlRegex = /^(https?:\/\/|ftp:\/\/)?([\w\-]+\.)+[\w\-]{2,}(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/i;

    if (link && !urlRegex.test(link)) {
      this.toastr.warning('Please enter a valid tracking URL', 'Warning');
      return;
    }

    if (!this.isUpdateTrackingMode && !link) {
      this.toastr.warning('Please paste tracking link', 'Warning');
      return;
    }

    let obj: any = {
      BookingId: this.currentTrackingData.BookingId || this.BookingId,
      ConsignmentDetailId: this.currentTrackingData.ConsignmentDetailId || this.currentTrackingData.Id,
      TrackingUrl: link,
      UserId: this.userId
    };

    Helpers.setLoading(true);
    this._appService.Post("OrdersByVehicle", "SaveTrackingLink", obj).subscribe(
      (response) => {
        Helpers.setLoading(false);
        let msg = this.isUpdateTrackingMode
          ? (link ? "Tracking link updated successfully" : "Tracking link removed successfully")
          : "Tracking link added successfully";
        this.toastr.success(msg, "Success");
        this.modalRef.close();
        this.GetOrderVehicleById(this.SelectedId);
      },
      (err) => {
        Helpers.setLoading(false);
        this.toastr.error(err._body.replace(/"/g, ""), "error");
      }
    );
  }
  // end by burhan

  // Added by priya - 23/06/2026 - cn(PRIYA-JUN26-007)
  GetsystemSettingValueForCalculateTime() {
    this._appService.GetById("Common", "GetSystemSettingByName", "IsCalculateTravelTimeByVehicleKm").subscribe(
      (response) => {
        if (response == "1") {
          this.IsCalculateTravelTimeByVehicleKm = true;
        } else {
          this.IsCalculateTravelTimeByVehicleKm = true;
        }
      },
      (err) => {
        this.toastr.error("Error occurred while fetching data !", "error");
      }
    );
  }

  // Added by priya - 27/07/2026 - cn(PRIYA-JUL26-016)
  LoadFtlMarkedContainerPicked() {
    this._appService.GetById("Common", "GetSystemSettingByName", "FtlMarkedContainerPicked").subscribe((response) => {
      if (response == '1') {
        this.IsFtlMarkedContainerPicked = true;
      } else {
        this.IsFtlMarkedContainerPicked = false;
      }
      localStorage.setItem('IsFtlMarkedContainerPicked', response);
    },
      (err) => {
        this.toastr.error("Error occurred while fetching Status data !", "error");
      });
  }

}